(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["modular-builder-draft"]) return;
  try {
    
(() => {
// Part-level compatibility from the supplied master grid. The current catalog
// remains responsible for electronics labels, prices, finish and availability.
function createCompatibilityGrid(spec) {
  const aliases=spec.aliases||{}, bundles=spec.bundles||{}, rules=spec.rules;
  const canonical=sku=>{
    const s=String(sku||'').trim().toUpperCase().replace(/BLK/g,'').replace(/X\d+$/,'');
    return aliases[s]||s;
  };
  const tokens=sku=>String(sku||'').replace(/_/g,'+').split('+').filter(Boolean).flatMap(s=>{
    const key=canonical(s);return bundles[key]||[key];
  });
  const plateKey=sku=>tokens(sku).sort().join('+');
  const roles=['mount','plate','bar','top','spreader','wedge','hinge','fold'];
  const known=Object.fromEntries(roles.map(role=>[role,new Set(rules.flatMap(r=>r[role]))]));
  const rowsFor=(setup,mount,plate)=>{
    const m=canonical(mount),p=plateKey(plate);
    // New catalog parts absent from the sheet continue to use the established
    // fitting rules. Absence of a combination of two covered parents is a deny.
    if(!known.mount.has(m)||!known.plate.has(p))return null;
    return rules.filter(r=>r.style===(setup==='dual'?'D':'S')&&r.mount.includes(m)&&r.plate.includes(p));
  };
  const narrow=(rows,role,sku)=>{
    if(rows===null||!sku)return rows;
    const required=tokens(sku).filter(s=>known[role].has(s));
    return rows.filter(r=>required.every(s=>r[role].includes(s)));
  };
  return {
    rowsFor,narrow,
    listed:(role,sku)=>tokens(sku).every(s=>known[role].has(s)),
    pairAllowed:(setup,mount,plate)=>{const rows=rowsFor(setup,mount,plate);return rows===null||rows.length>0;},
    allows:(rows,role,sku)=>{const matches=narrow(rows,role,sku);return matches===null||matches.length>0;},
  };
}

const applyBuilderCatalogRevisions = products => products.map(product => {
  if (!product || product.handle !== 'spreader-kits') return product;
  const variants = product.variants.map(variant => {
    const match = variant.sku.match(/^(SP[12]MOD(?:BLK)?V2)\+SPLTLEDV[23](?:x([12]))?$/i);
    if (!match) return variant;
    const spreader = product.variants.find(v => v.sku === match[1]);
    if (!spreader) return null;
    const quantity = Number(match[2] || 1);
    return {...variant, sourceSku:variant.sku, sourcePrice:variant.price,
      sku:variant.sku.replace(/SPLTLEDV2/gi,'SPLTLEDV3'),
      price:Number(spreader.price) + quantity * 20000,
      available:false, availabilityUnknown:true, draftReplacement:true};
  }).filter(Boolean);
  return {...product, variants};
});

const mountPrintDocument = (content,title,portrait=false) => {
  const safe=String(title).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  return `<!doctype html><html><head><meta charset="utf-8"><title>${safe}</title><style>@page{size:letter ${portrait?'portrait':'landscape'};margin:8mm}html,body{margin:0;padding:0;background:white}body{width:${portrait?184:254}mm;height:${portrait?254:184}mm}svg{display:block;width:100%;height:100%;break-inside:avoid;page-break-inside:avoid}*{box-sizing:border-box}</style></head><body>${content}</body></html>`;
};

const printMountSvg = (content,title,portrait=false) => {
  const frame=document.createElement('iframe');
  frame.setAttribute('data-mount-print-frame','');frame.setAttribute('aria-hidden','true');frame.title=title;
  frame.style.cssText='position:fixed;left:-12000px;top:0;width:1100px;height:800px;border:0;pointer-events:none';
  const cleanup=()=>{frame.onload=null;frame.remove();};
  frame.onload=()=>{
    const target=frame.contentWindow;
    target.addEventListener('afterprint',cleanup,{once:true});
    target.focus();target.print();
  };
  frame.srcdoc=mountPrintDocument(content,title,portrait);document.body.append(frame);
  return cleanup;
};

const mountPartsEmailContent = (parts,summary,notes,url,t,esc,money) => {
  const href=esc(url);
  const total=money(parts.reduce((sum,[,item])=>sum+item.price*(item.quantity||1),0));
  const rows=parts.map(([role,item])=>`<tr><td style="padding:16px 0;border-bottom:1px solid #dbe5eb;vertical-align:top"><p style="margin:0 0 4px;font-size:16px;line-height:1.5;color:#16394d"><strong>${esc(t(role))}:</strong> ${esc(item.sku)}</p><p style="margin:0 0 5px;font-size:14px;line-height:1.5;color:#344c5a">${esc(item.shortDescription)}</p><p style="margin:0;font-size:14px;line-height:1.5;color:#526c7b">${esc(t('email_quantity'))}: ${item.quantity||1} &nbsp; | &nbsp; ${esc(t('email_unit_price'))}: ${esc(money(item.price))}</p></td></tr>`).join('');
  const html=`<div style="font-family:Arial,Helvetica,sans-serif;font-size:16px;line-height:1.5;color:#16394d;max-width:640px"><p style="margin:0 0 16px;font-size:20px;line-height:1.4;font-weight:700;color:#16394d">${esc(t('email_intro'))}</p><p style="margin:0 0 12px;font-size:15px;line-height:1.5;color:#344c5a">${esc(summary)}</p><p style="margin:0 0 8px;font-size:15px;line-height:1.5"><a href="${href}" style="color:#086591;text-decoration:underline">${esc(t('email_view_build'))}</a></p><table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="width:100%;border-collapse:collapse"><tbody>${rows}</tbody></table><p style="margin:20px 0;font-size:17px;line-height:1.5;color:#16394d"><strong>${esc(t('subtotal'))}: ${esc(total)}</strong></p>${notes.length?`<div style="margin:0 0 20px;font-size:13px;line-height:1.5;color:#526c7b">${notes.map(note=>`<p style="margin:0 0 8px">${esc(note)}</p>`).join('')}</div>`:''}<table role="presentation" cellpadding="0" cellspacing="0" border="0" style="border-collapse:separate"><tbody><tr><td bgcolor="#086591" style="background-color:#086591;border-radius:6px;text-align:center"><a href="${href}" style="display:inline-block;padding:14px 20px;border:1px solid #086591;border-radius:6px;color:#ffffff;background-color:#086591;font-family:Arial,Helvetica,sans-serif;font-size:15px;line-height:1.5;font-weight:700;text-decoration:none">${esc(t('email_order_build'))}</a></td></tr></tbody></table></div>`;
  const text=[t('email_intro'),summary,...parts.map(([role,item])=>`${t(role)}: ${item.sku}\n${item.shortDescription}\n${t('email_quantity')}: ${item.quantity||1} | ${t('email_unit_price')}: ${money(item.price)}`),`${t('subtotal')}: ${total}`,...notes,t('email_order_build')+'\n'+url].join('\n\n');
  return {html,text};
};

const copyMountPartsEmail = async (preview,content) => {
  if(navigator.clipboard?.write&&typeof ClipboardItem!=='undefined'){
    try{
      await navigator.clipboard.write([new ClipboardItem({'text/html':new Blob([content.html],{type:'text/html'}),'text/plain':new Blob([content.text],{type:'text/plain'})})]);
      return true;
    }catch{}
  }
  const selection=window.getSelection();
  if(!selection)return false;
  preview.focus();
  const range=document.createRange();range.selectNodeContents(preview);selection.removeAllRanges();selection.addRange(range);
  let copied=false;
  const handleCopy=event=>{
    if(!event.clipboardData)return;
    event.clipboardData.setData('text/html',content.html);
    event.clipboardData.setData('text/plain',content.text);
    event.preventDefault();copied=true;
  };
  document.addEventListener('copy',handleCopy);
  try{document.execCommand('copy');}catch{}
  document.removeEventListener('copy',handleCopy);
  if(copied)selection.removeAllRanges();
  return copied;
};

const mountPartsPrintMarkup = (parts,summary,warnings,t,esc,money,orderingNote) => {
  const wrap=(value,width=88)=>String(value).match(new RegExp('.{1,'+width+'}(?:\\s|$)|\\S{1,'+width+'}','g'))?.map(s=>s.trim())||[''];
  const txt=(x,y,s,size=16,weight=400)=>`<text x="${x}" y="${y}" font-family="Arial,Helvetica,sans-serif" font-size="${size}" font-weight="${weight}" fill="#16394d">${esc(s)}</text>`;
  let y=115,body=txt(30,38,'SEAVIEW · '+t('parts_list'),25,700)+txt(30,71,summary,15);
  for(const [role,v] of parts){
    const lines=wrap(v.shortDescription||t(role),78);
    body+=`<path d="M30 ${y-18}H770" stroke="#c9d5dc"/>`+txt(30,y,v.sku,17,700)+txt(655,y,money(v.price*(v.quantity||1)),16,700);
    lines.forEach((s,i)=>body+=txt(30,y+21+i*18,s,14));y+=40+lines.length*18;
  }
  body+=`<path d="M30 ${y-16}H770" stroke="#8ca5b5"/>`+txt(30,y+7,t('subtotal'),18,700)+txt(635,y+7,money(parts.reduce((n,[,v])=>n+v.price*(v.quantity||1),0)),20,700);y+=43;
  const notes=[t('price_note'),...(parts.some(([,v])=>v.draftReplacement)?[t('replacement_price_note')]:[]),...(warnings.length?[t('review'),...warnings]:[]),orderingNote];
  for(const note of notes)for(const s of wrap(note,100)){body+=txt(30,y,s,13);y+=18;}
  const height=Math.max(1035,y+25);
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 ${height}" width="800" height="${height}"><rect width="800" height="${height}" fill="white"/>${body}</svg>`;
};

const mountModelKey = value => value.replace(/^PMA200V3(?:\+LTBLED12C5)?$/,'PMA200SV3').replace(/^PMABC37SV2$/,'PMABC37S').replace(/^PMA100SV2$/,'PMA100S').replace(/^PMA200V2$/,'PMA200SV2').replace(/^PMA57LSS\+ADAHALO3$/,'PMA57LSS').replace(/BLK/g,'').replace(/\s*-\s*Made to Order\s*$/i,'').replace(/^(SP[12]MOD(?:V2)?)(?:\+.*)?$/,(_,s)=>s.replace(/MOD$/,'MODV2')).replace(/^LTBLED24C5$/,'LTBLED12C5');
const buildMountAssembly = (parts, connections, exploded=false, configuration={}) => {
  const sku=v=>mountModelKey(v.sku),byRole=Object.fromEntries(parts);
  const get=role=>byRole[role]&&connections[sku(byRole[role])];
  const mount=get('mount'),plate=get('plate'),bar=get('bar'),hingeBase=get('hinge'),removable=get('removable'),wedge=get('wedge'),starlinkWedge=get('starlink_wedge'),fold=get('fold');
  // The selector has already applied the master-grid fit rules. Some approved
  // PMADM3M1 combinations use SP2 despite the M1 suffix on the mount.
  const spreader=get('spreader'),spreaderSku=byRole.spreader&&sku(byRole.spreader);
  const hingeModel=hingeBase?.mountOffset&&wedge?'SVEHB1-'+sku(byRole.wedge):undefined;
  const hinge=connections[hingeModel]||hingeBase;
  const result=[],baseRoles=[];let baseOffset=[0,0,0];
  const sum=(a,b)=>a.map((v,i)=>v+b[i]);
  const add=(role,position,model,requires)=>{
    const v=byRole[role],c=v&&connections[sku(v)];if(!c||!position)return;
    const level={wedge:0,hinge:1,removable:2,mount:3,spreader:4,bar:6,fold:5,plate:5,starlink_wedge:6,top:7}[role];
    result.push({role,sku:sku(v),model:model||sku(v),rotation:(model&&connections[model]||c).rotation,
      translation:position.map((x,i)=>x+(exploded&&i===1?level*.10:0)),part:v,requires:requires||[]});
  };
  const base=(role,c)=>{if(c){add(role,sum(c.translation,baseOffset),role==='hinge'?hingeModel:null,[...baseRoles]);baseRoles.push(role);baseOffset=sum(baseOffset,c.mountOffset||[0,c.lift||0,0]);}};
  if(mount){
    // Electric hinge has its own deck footprint; mount-sized adapters sit on its
    // mounting plate. Manual hinges and removable bases share the mount pattern.
    if(hinge?.mountOffset)base('hinge',hinge);
    base('wedge',wedge);base('removable',removable);
    if(!hinge?.mountOffset)base('hinge',hinge);
    add('mount',sum(mount.translation,baseOffset),null,[...baseRoles]);
    const mountTop=mount.top&&sum(mount.top,baseOffset);
    const origin=mountTop&&sum(mountTop,[0,spreader?.lift||0,0]);
    if(spreader&&mountTop){
      const posts=configuration.category?configuration.category==='dome':/^ADAR/.test(byRole.plate?.sku||'');
      add('spreader',sum(spreader.translation,mountTop),posts?spreaderSku:spreader.noPostsModel,['mount']);
    }
    if(plate&&origin){
      const upperRequires=['mount',...(spreader?['spreader']:[])];
      const plateOrigin=sum(origin,[0,bar?.mountInterface?bar.plateLift||0:0,0]);
      add('plate',sum(plate.translation,plateOrigin),null,upperRequires);
      if(starlinkWedge){
        const starlinkWedgeOrigin=sum(plateOrigin,[0,plate.starlinkWedgeOffset||0,0]);
        add('starlink_wedge',sum(starlinkWedge.translation,starlinkWedgeOrigin),null,[...upperRequires,'plate']);
      }
      if(bar&&(Number.isFinite(plate.barOffset)||bar.mountInterface)){
        const barOrigin=bar.mountInterface?origin:sum(plateOrigin,[plate.barOffset,0,0]);
        if(fold)add('fold',sum(fold.translation,barOrigin),null,[...upperRequires,'plate']);
        add('bar',sum(bar.translation,barOrigin),fold?bar.foldModel:null,[...upperRequires,'plate',...(fold?['fold']:[])]);
        const light=get('top');
        if(light&&bar.light){
          const reference=connections.LTBR.light;
          add('top',light.translation.map((x,i)=>x+barOrigin[i]+bar.light[i]-reference[i]),null,[...upperRequires,'plate','bar']);
        }
      }
    }
  }

        if(mount?.integratedPlate){
          const entry=result.find(p=>p.role==='mount');
          if(entry){
            result.push({role:'included_plate',sku:byRole.mount.sku,model:mount.integratedPlate,rotation:entry.rotation,translation:entry.translation.map((x,i)=>x+(exploded&&i===1?.4:0)),part:{...byRole.mount,color:'white'},requires:['mount']});
            if(bar&&mount.barOrigin){
              const barOrigin=sum(mount.barOrigin,baseOffset);
              add('bar',sum(bar.translation,barOrigin),null,['mount','included_plate']);
              const light=get('top');
              if(light&&bar.light)add('top',light.translation.map((x,i)=>x+barOrigin[i]+bar.light[i]-connections.LTBR.light[i]),null,['mount','included_plate','bar']);
            }
          }
        }

  if(byRole.floodlight&&mount?.floodlights){
    const entry=result.find(p=>p.role==='mount');
    if(entry)mount.floodlights.slice(0,byRole.floodlight.quantity||1).forEach((site,i)=>{
      const c=connections[site.model];
      if(c)result.push({role:i?'floodlight2':'floodlight',sku:byRole.floodlight.sku,model:site.model,rotation:c.rotation,translation:site.position.map((x,k)=>x+entry.translation[k]+(exploded&&k===1?.025:0)),part:byRole.floodlight,requires:['mount']});
    });
  }

  if(mount?.navOrigin&&byRole.mount?.sku==='PMA200V3+LTBLED12C5'){
    const entry=result.find(p=>p.role==='mount');
    if(entry)result.push({role:'included_nav',sku:'LTBLED12C5',model:'LTBLED12C5',rotation:[1,0,0,0,1,0,0,0,1],translation:mount.navOrigin.map((x,i)=>x+entry.translation[i]+[-.0255,0,-.029075][i]+(exploded&&i===1?.12:0)),part:{...byRole.mount,sku:'LTBLED12C5',color:'white'},requires:['mount'],included:true});
  }
  const pending=parts.filter(([role])=>!result.some(p=>p.role===role)).map(([role,v])=>[role,plate&&sku(byRole.plate)==='ADAS2V7'&&['bar','top'].includes(role)?{...v,previewNote:'adas2v7_connection'}:v]);
  if(mount?.integratedPlate&&byRole.mount.sku.includes('+ADAHALO3'))pending.push(['mount',{...byRole.mount,previewSku:'ADAHALO3',previewNote:'geometry_pending'}]);
  const spreaderEntry=result.find(p=>p.role==='spreader');
  if(spreaderEntry&&byRole.spreader.sku.includes('+')){
    const [previewSku,quantity='1']=byRole.spreader.sku.split('+')[1].split(/x/i);
    const lightSku=previewSku.replace(/^SPLTLEDV2$/,'SPLTLEDV3'),sites=spreader.floodlights;
    if(lightSku==='SPLTLEDV3'&&sites?.length>=Number(quantity)){
      for(let i=0;i<Number(quantity);i++){
        const site=sites[i],c=connections[site.model];
        if(!c){pending.push(['spreader',{...byRole.spreader,previewSku:lightSku,previewNote:'floodlights_pending'}]);continue;}
        result.push({role:'floodlight'+(i+1),sku:lightSku,model:site.model,rotation:c.rotation,
          translation:c.translation.map((x,k)=>x+site.position[k]+spreaderEntry.translation[k]+(exploded&&k===1?.025:0)),
          part:{...byRole.spreader,sku:lightSku,color:'white'},requires:['mount','spreader']});
      }
    }else pending.push(['spreader',{...byRole.spreader,previewSku:lightSku,previewQuantity:Number(quantity),previewNote:'floodlights_pending'}]);
  }
  return {placed:result,pending};
};

const createMountViewer = (root, t, esc, media) => {
  const el = key => root.querySelector(`[data-${key}]`);
  const canvas = el('three-canvas');
  const catalog = Object.assign(JSON.parse(el('model-manifest').textContent),JSON.parse(el('model-additions')?.textContent||'{}'));
  const embedded = el('embedded-models') ? JSON.parse(el('embedded-models').textContent) : {};
  const connections=JSON.parse(el('assembly-connections').textContent);
  const cache = new Map();
  let gl, program, uniforms, attributes, failed=false, serial=0, frame=0;
  let entries=[], meshes=[], selected=[], pending=[], mode='3d', exploded=false, signature='';
  let center=[0,0,0],radius=1;
  let yaw=-0.65, pitch=0.42, zoom=1;
  const showError = () => {failed=true;el('three-status').textContent=t('three_unavailable');el('three-stage').hidden=true;el('photo-stage').hidden=false;};
  try {
    gl=canvas.getContext('webgl2',{antialias:true,alpha:false,preserveDrawingBuffer:true});
    if(!gl)throw new Error('WebGL2 context unavailable');
    const shader=(type,source)=>{const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(s));return s;};
    program=gl.createProgram();
    gl.attachShader(program,shader(gl.VERTEX_SHADER,`#version 300 es
      in vec3 position; in vec3 normal;
      uniform mat4 matrix; uniform mat3 rotation; uniform mat3 partRotation; uniform vec3 partOffset;
      out vec3 surfaceNormal; out vec3 surfacePosition;
      void main(){vec3 world=partRotation*position+partOffset;surfaceNormal=rotation*partRotation*normal;surfacePosition=rotation*world;gl_Position=matrix*vec4(world,1.0);}`));
    gl.attachShader(program,shader(gl.FRAGMENT_SHADER,`#version 300 es
      precision highp float;
      in vec3 surfaceNormal; in vec3 surfacePosition; uniform vec3 color; out vec4 pixel;
      void main(){vec3 n=normalize(surfaceNormal);if(!gl_FrontFacing)n=-n;
      float key=max(dot(n,normalize(vec3(-0.5,0.85,1.0))),0.0);
      float fill=max(dot(n,normalize(vec3(0.9,0.25,-0.4))),0.0);
      float spec=pow(max(dot(reflect(-normalize(vec3(-0.5,0.85,1.0)),n),vec3(0,0,1)),0.0),22.0);
      vec3 lit=color*(0.36+0.59*key+0.20*fill)+vec3(0.13)*spec;
      pixel=vec4(pow(lit,vec3(0.72)),1.0);}`));
    gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw new Error(gl.getProgramInfoLog(program));
    uniforms=Object.fromEntries(['matrix','rotation','color','partRotation','partOffset'].map(k=>[k,gl.getUniformLocation(program,k)]));
    attributes=Object.fromEntries(['position','normal'].map(k=>[k,gl.getAttribLocation(program,k)]));
    gl.enable(gl.DEPTH_TEST);gl.enable(gl.SCISSOR_TEST);
  } catch(error) {canvas.dataset.previewError=error.message;showError();}
  const modelKey=v=>mountModelKey(v.previewSku||v.sku);
  const pendingLabel=v=>(v.previewSku||v.sku)+(v.previewQuantity>1?' × '+v.previewQuantity:'');
  const pendingNote=v=>t(v.previewNote||(catalog[modelKey(v)]?'model_pending':'geometry_pending'));
  const pendingText=v=>pendingLabel(v)+': '+pendingNote(v);
  const load = async sku => {
    if(cache.has(sku))return cache.get(sku);
    const task=(async()=>{
      const asset=catalog[sku];if(!asset)throw new Error('missing');
      const readAsset=url=>fetch(url,{credentials:'omit'}).then(r=>{if(!r.ok)throw new Error('download');return r.json();});
      const raw=embedded[sku] || (Array.isArray(asset)?JSON.parse((await Promise.all(asset.map(readAsset))).join('')):await readAsset(asset));
      const compressed=Uint8Array.from(atob(raw.gzip),c=>c.charCodeAt(0));
      const buffer=await new Response(new Blob([compressed]).stream().pipeThrough(new DecompressionStream('gzip'))).arrayBuffer();
      const normalBytes=raw.version===2?2:1,stride=6+normalBytes*3;
      if(buffer.byteLength!==raw.vertices*stride+raw.indices*4)throw new Error('invalid geometry');
      const view=new DataView(buffer),pos=new Float32Array(raw.vertices*3),normal=new Float32Array(raw.vertices*3),indices=new Uint32Array(raw.indices);
      for(let i=0;i<pos.length;i++){pos[i]=view.getUint16(i*2,true)/65535*raw.extent[i%3]+raw.min[i%3];normal[i]=normalBytes===2?view.getInt16(raw.vertices*6+i*2,true)/32767:view.getInt8(raw.vertices*6+i)/127;}
      for(let i=0;i<indices.length;i++)indices[i]=view.getUint32(raw.vertices*stride+i*4,true);
      const upload=(target,data)=>{const b=gl.createBuffer();gl.bindBuffer(target,b);gl.bufferData(target,data,gl.STATIC_DRAW);return b;};
      return {position:upload(gl.ARRAY_BUFFER,pos),normal:upload(gl.ARRAY_BUFFER,normal),index:upload(gl.ELEMENT_ARRAY_BUFFER,indices),count:indices.length,min:raw.min,extent:raw.extent};
    })();cache.set(sku,task);try{return await task;}catch(error){cache.delete(sku);throw error;}
  };
  function draw(){
    frame=0;if(failed||mode!=='3d'||el('three-stage').hidden)return;
    const rect=canvas.getBoundingClientRect(),dpr=Math.min(Math.max(devicePixelRatio||1,1.5),2);
    const w=Math.max(1,Math.round(rect.width*dpr)),h=Math.max(1,Math.round(rect.height*dpr));
    if(canvas.width!==w||canvas.height!==h){canvas.width=w;canvas.height=h;}
    gl.scissor(0,0,w,h);gl.clearColor(0.938,0.956,0.968,1);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);
    gl.useProgram(program);
    const cy=Math.cos(yaw),sy=Math.sin(yaw),cp=Math.cos(pitch),sp=Math.sin(pitch);
    const r=[cy,sp*sy,-cp*sy,0,cp,sp,sy,-sp*cy,cp*cy];
    gl.uniformMatrix3fv(uniforms.rotation,false,r);
    const aspect=w/h,scale=zoom*.88*Math.min(aspect,1)/radius;
    const z=-1/(radius*4);
    const matrix=new Float32Array([r[0]*scale/aspect,r[1]*scale,r[2]*z,0,r[3]*scale/aspect,r[4]*scale,r[5]*z,0,r[6]*scale/aspect,r[7]*scale,r[8]*z,0,0,0,0,1]);
    for(let row=0;row<3;row++)matrix[12+row]=-(matrix[row]*center[0]+matrix[4+row]*center[1]+matrix[8+row]*center[2]);
    gl.viewport(0,0,w,h);gl.scissor(0,0,w,h);
    gl.uniformMatrix4fv(uniforms.matrix,false,matrix);
    entries.forEach((entry,i)=>{
      const m=meshes[i];if(!m)return;
      const v=entry.part,rot=entry.rotation;
      gl.uniformMatrix3fv(uniforms.partRotation,false,[rot[0],rot[3],rot[6],rot[1],rot[4],rot[7],rot[2],rot[5],rot[8]]);
      gl.uniform3fv(uniforms.partOffset,entry.translation);
      gl.uniform3fv(uniforms.color,v.color === 'black' ? [.08,.095,.11] : v.color === 'steel' ? [.64,.69,.74] : [.91,.935,.95]);
      for(const name of ['position','normal']){gl.bindBuffer(gl.ARRAY_BUFFER,m[name]);gl.enableVertexAttribArray(attributes[name]);gl.vertexAttribPointer(attributes[name],3,gl.FLOAT,false,0,0);}
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,m.index);gl.drawElements(gl.TRIANGLES,m.count,gl.UNSIGNED_INT,0);
    });
    canvas.dataset.rendered=String(meshes.filter(Boolean).length);
  }
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(draw);};
  const fit=()=>{
    const lo=[Infinity,Infinity,Infinity],hi=[-Infinity,-Infinity,-Infinity];
    entries.forEach((e,i)=>{const m=meshes[i];if(!m)return;
      for(let corner=0;corner<8;corner++){
        const p=m.min.map((x,k)=>x+((corner>>k)&1)*m.extent[k]);
        for(let k=0;k<3;k++){
          const x=e.translation[k]+e.rotation[k*3]*p[0]+e.rotation[k*3+1]*p[1]+e.rotation[k*3+2]*p[2];
          lo[k]=Math.min(lo[k],x);hi[k]=Math.max(hi[k],x);
        }
      }
    });
    if(lo.every(Number.isFinite)){center=lo.map((x,i)=>(x+hi[i])/2);radius=Math.max(.02,Math.hypot(...hi.map((x,i)=>x-lo[i]))/2);}
  };
  const refresh=async()=>{
    const current=++serial;
    el('three-mode').setAttribute('aria-pressed',String(mode==='3d'));
    el('photo-mode').setAttribute('aria-pressed',String(mode==='photos'));
    el('three-options').hidden=mode!=='3d'||failed;el('three-download').hidden=mode!=='3d'||failed;el('three-status').hidden=mode!=='3d';
    el('three-stage').hidden=mode!=='3d'||failed;
    el('photo-stage').hidden=mode==='3d'&&!failed;
    el('three-note').hidden=mode!=='3d'||failed;el('photo-note').hidden=mode==='3d'&&!failed;
    el('three-overlays').hidden=true;
    el('three-all').setAttribute('aria-pressed',String(exploded));
    el('three-one').setAttribute('aria-pressed',String(!exploded));
    if(mode!=='3d'||failed)return;
    const assembly=buildMountAssembly(selected,connections,exploded,{category:el('category').value});
    entries=assembly.placed;pending=assembly.pending;meshes=[];
    if(el('geometry-note'))el('geometry-note').hidden=!entries.some(e=>connections[e.model]?.representativeFor);
    el('three-status').textContent=selected.length?t('three_loading'):t('three_empty');
    el('three-save').disabled=true;schedule();
    const results=await Promise.allSettled(entries.map(e=>load(e.model)));
    if(current!==serial)return;
    meshes=results.map(r=>r.status==='fulfilled'?r.value:null);
    const loaded=role=>meshes[entries.findIndex(e=>e.role===role)];
    entries.forEach((e,i)=>{
      if(e.requires.some(role=>!loaded(role)))meshes[i]=null;
      if(!meshes[i])pending.push([e.role,{...e.part,previewNote:results[i].status==='rejected'?(catalog[e.model]?'model_load_failed':'geometry_pending'):'parent_model_pending'}]);
    });
    pending=pending.map(([role,v])=>[role,v.previewNote==='floodlights_pending'&&!loaded('spreader')?{...v,previewNote:'geometry_pending'}:v]);
    el('three-overlays').innerHTML=pending.map(([,v])=>`<div class="mb-pending-part">${media(v)}<span><strong>${esc(pendingLabel(v))}</strong><small>${esc(pendingNote(v))}</small></span></div>`).join('');
    el('three-overlays').hidden=!pending.length;
    el('three-status').textContent=pending.length?pending.map(([,v])=>pendingText(v)).join(' · '):entries.length?t('three_instructions'):t('three_empty');
    canvas.dataset.assemblyParts=entries.filter((_,i)=>meshes[i]).map(e=>e.sku).join(',');
    canvas.dataset.assemblyMode=exploded?'exploded':'assembled';
    el('three-save').disabled=!meshes.some(Boolean);fit();schedule();
  };
  root.addEventListener('click',e=>{
    const b=e.target.closest('button');if(!b)return;
    if(b.hasAttribute('data-three-mode')){mode='3d';refresh();}
    if(b.hasAttribute('data-photo-mode')){mode='photos';refresh();}
    if(b.hasAttribute('data-three-all')){exploded=true;refresh();}
    if(b.hasAttribute('data-three-one')){exploded=false;refresh();}
    if(b.hasAttribute('data-three-reset')){yaw=-0.65;pitch=0.42;zoom=1;schedule();}
    if(b.hasAttribute('data-three-save')){
      draw();const out=document.createElement('canvas');
      const lines=[t(exploded?'three_exploded':'three_caption'),...entries.filter((_,i)=>meshes[i]).map(e=>e.part.sku),...pending.map(([,v])=>pendingText(v)),t('three_export_note')];
      if(entries.some(e=>connections[e.model]?.representativeFor))lines.push(t('floodlight_geometry_note'));
      out.width=canvas.width;out.height=canvas.height+lines.length*20+20;
      const ctx=out.getContext('2d');ctx.fillStyle='#eff4f7';ctx.fillRect(0,0,out.width,out.height);ctx.drawImage(canvas,0,0);
      ctx.fillStyle='#16394d';ctx.font='12px Arial';lines.forEach((line,i)=>ctx.fillText(line,12,canvas.height+22+i*20,out.width-24));
      const a=document.createElement('a');a.download='Seaview-mount-assembly.png';a.href=out.toDataURL('image/png');a.click();
    }
  });
  const pointers=new Map();let lastDistance=0;
  canvas.addEventListener('pointerdown',e=>{canvas.setPointerCapture(e.pointerId);pointers.set(e.pointerId,[e.clientX,e.clientY]);});
  canvas.addEventListener('pointermove',e=>{const old=pointers.get(e.pointerId);if(!old)return;pointers.set(e.pointerId,[e.clientX,e.clientY]);if(pointers.size===2){const [a,b]=[...pointers.values()],d=Math.hypot(a[0]-b[0],a[1]-b[1]);if(lastDistance)zoom=Math.max(0.5,Math.min(2.5,zoom*d/lastDistance));lastDistance=d;}else{yaw+=(e.clientX-old[0])*0.012;pitch=Math.max(-1.4,Math.min(1.4,pitch+(e.clientY-old[1])*0.012));}schedule();});
  const release=e=>{pointers.delete(e.pointerId);lastDistance=0;};
  canvas.addEventListener('pointerup',release);canvas.addEventListener('pointercancel',release);
  canvas.addEventListener('wheel',e=>{if(document.activeElement!==canvas)return;e.preventDefault();zoom=Math.max(0.5,Math.min(2.5,zoom*Math.exp(-e.deltaY*0.001)));schedule();},{passive:false});
  canvas.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','+','=','-'].includes(e.key))return;e.preventDefault();if(e.key==='ArrowLeft')yaw-=0.15;if(e.key==='ArrowRight')yaw+=0.15;if(e.key==='ArrowUp')pitch-=0.15;if(e.key==='ArrowDown')pitch+=0.15;if(['+','='].includes(e.key))zoom=Math.min(2.5,zoom+0.1);if(e.key==='-')zoom=Math.max(0.5,zoom-0.1);pitch=Math.max(-1.4,Math.min(1.4,pitch));schedule();});
  canvas.addEventListener('webglcontextlost',e=>{e.preventDefault();showError();});
  const resize=new ResizeObserver(schedule);resize.observe(canvas);
  return {update(parts,key){const next=JSON.stringify([parts.map(([k,v])=>[k,v.sku,v.quantity||1]),el('category').value]);selected=parts;if(next===signature)return;signature=next;refresh();},destroy(){resize.disconnect();if(frame)cancelAnimationFrame(frame);if(gl){for(const p of cache.values())p.then(m=>{for(const k of ['position','normal','index'])gl.deleteBuffer(m[k]);}).catch(()=>{});gl.deleteProgram(program);}}};
};

const measureMountDrawing = (parts, connections, data, category) => {
  const assembly=buildMountAssembly(parts,connections,false,{category});
  const pending=[...assembly.pending],placed=[];
  for(const entry of assembly.placed){
    const model=data.models[entry.model];
    if(!model||JSON.stringify(model.rotation)!==JSON.stringify(entry.rotation)||entry.requires.some(role=>!placed.some(e=>e.role===role))){
      pending.push([entry.role,entry.part]);continue;
    }
    placed.push({...entry,drawing:model,offset:entry.translation.map(n=>n*1000)});
  }
  const min=[0,1,2].map(axis=>Math.min(...placed.map(e=>e.drawing.min[axis]+e.offset[axis])));
  const max=[0,1,2].map(axis=>Math.max(...placed.map(e=>e.drawing.max[axis]+e.offset[axis])));
  const mountPart=parts.find(([role])=>role==='mount')?.[1],mountSku=mountPart?.sku.replace(/BLK/g,'');
  // The published product table establishes only these base envelopes for
  // complete dedicated no-light-bar mounts. Hole and cable-opening data is
  // deliberately omitted until a dedicated installation drawing is supplied.
  const dedicatedBase=mountPart?.dedicated?{shape:mountSku.startsWith('PMA')?'square':'round',size:mountSku.startsWith('PMA')?177.8:203.2,holes:[],source:'Published dedicated-mount dimensional table'}:null;
  const base=data.installation?.mounts[mountSku]||dedicatedBase,mountEntry=placed.find(p=>p.role==='mount'),plateEntry=placed.find(p=>p.role==='plate');
  const datum=mountEntry?(mountEntry.translation[1]-connections[mountSku].translation[1])*1000:0;
  const platforms=[];
  if(base&&Number.isFinite(base.lowerY))platforms.push({key:'drawing_lower_height',height:base.lowerY,world:base.lowerY+datum});
  const plateOffset=plateEntry&&data.installation?.plateOffsets[plateEntry.sku];
  if(plateEntry&&Number.isFinite(plateOffset)){
    const world=plateEntry.offset[1]-connections[plateEntry.sku].translation[1]*1000+plateOffset;
    platforms.push({key:'drawing_upper_height',height:world-datum,world});
  }
  const arm=placed.find(p=>p.role==='bar'),armOffset=arm&&data.installation?.armOffsets?.[arm.sku];
  if(arm&&Number.isFinite(armOffset)){
    const world=arm.offset[1]-connections[arm.sku].translation[1]*1000+armOffset;
    platforms.push({key:'drawing_arm_height',height:world-datum,world});
  }
  const starlinkWedge=placed.find(p=>p.role==='starlink_wedge');
  if(starlinkWedge){
    const world=starlinkWedge.offset[1]+starlinkWedge.drawing.max[1];
    platforms.push({key:'drawing_starlink_wedge_height',height:world-datum,world});
  }
  return {placed,pending,min,max,size:max.map((v,i)=>v-min[i]),complete:pending.length===0&&placed.length>0,base,mountSku,datum,platforms,representative:placed.some(p=>connections[p.model]?.representativeFor)};
};

const createMountDrawing = (root,t,esc) => {
  const el=key=>root.querySelector(`[data-${key}]`);
  const dialog=el('drawing-dialog'),trigger=el('drawing-open');
  const connections=JSON.parse(el('assembly-connections').textContent);
  const manifest=JSON.parse(el('dimension-manifest').textContent);
  let selected=[],category='',signature='',data,loading,serial=0,current=null;
  const views=[{key:'front',axes:[2,1],labels:['dimension_width','dimension_height']},{key:'side',axes:[0,1],labels:['dimension_depth','dimension_height']},{key:'top',axes:[2,0],labels:['dimension_width','dimension_depth']}];
  const format=mm=>`${(mm/25.4).toFixed(2)} in / ${mm.toFixed(1)} mm`;
  const label=v=>(v.previewSku||v.sku)+(v.previewQuantity>1?' × '+v.previewQuantity:'');
  const load=async()=>{
    if(data)return data;
    if(!loading)loading=(async()=>{
      const embedded=el('embedded-dimensions');
      const value=embedded?JSON.parse(embedded.textContent):await fetch(manifest.url,{credentials:'omit'}).then(r=>{if(!r.ok)throw new Error('download');return r.json();});
      if(value.version!==1||value.units!=='mm'||!value.models)throw new Error('invalid drawing');
      return data=value;
    })().catch(error=>{loading=null;throw error;});
    return loading;
  };
  const line=(x1,y1,x2,y2,color='#628093')=>`<path d="M${x1},${y1}L${x2},${y2}" stroke="${color}" stroke-width="1" fill="none"/>`;
  const text=(x,y,value,extra='')=>`<text x="${x}" y="${y}" font-family="Arial,Helvetica,sans-serif" font-size="13" fill="#16394d" ${extra}>${esc(value)}</text>`;
  const viewMarkup=(measurement,view)=>{
    const [a,b]=view.axes,{min,max,size}=measurement;
    const scale=Math.min(310/Math.max(size[a],1),245/Math.max(size[b],1));
    const width=size[a]*scale,height=size[b]*scale;
    const left=68+(310-width)/2,top=52+(245-height)/2,right=left+width,bottom=top+height;
    let markup=text(24,28,t('drawing_'+view.key),'font-weight="700"');
    const depth=[0,1,2].find(axis=>!view.axes.includes(axis));
    const ordered=[...measurement.placed].sort((u,v)=>(u.drawing.max[depth]+u.offset[depth])-(v.drawing.max[depth]+v.offset[depth]));
    for(const entry of ordered){
      const dx=left+(entry.offset[a]-min[a])*scale,dy=bottom-(entry.offset[b]-min[b])*scale;
      const fill=view.key==='top'?(entry.role==='mount'?'#e3f1f7':entry.role==='plate'?'#ffffff':'#f4f7f9'):'#f4f7f9';
      markup+=`<path d="${entry.drawing.views[view.key]}" transform="translate(${dx} ${dy}) scale(${scale} ${-scale})" fill="${fill}" fill-rule="evenodd" stroke="#284c60" stroke-width="1.1" stroke-linejoin="round" vector-effect="non-scaling-stroke"><title>${esc(entry.part.sku)}</title></path>`;
    }
    if(view.key==='side'&&measurement.platforms.length){
      const baseY=bottom-(measurement.datum-min[1])*scale;
      markup+=`<path d="M${left-10},${baseY}H${right}" stroke="#086591" stroke-dasharray="4 3" fill="none"/>`+text(left-16,baseY+4,'0','text-anchor="end"');
      measurement.platforms.forEach((p,i)=>{const y=bottom-(p.world-min[1])*scale;markup+=`<path d="M${left-10},${y}H${right}" stroke="#086591" stroke-dasharray="4 3" fill="none"/>`+text(left-16,y+4,'H'+(i+1),'text-anchor="end"');});
    }
    const y=326,x=410;
    markup+=line(left,bottom+7,left,y+7)+line(right,bottom+7,right,y+7)+line(left,y,right,y);
    markup+=`<path d="M${left+7},${y-3}L${left},${y}L${left+7},${y+3} M${right-7},${y-3}L${right},${y}L${right-7},${y+3}" fill="none" stroke="#628093"/>`;
    markup+=text((left+right)/2,351,t(view.labels[0]),'text-anchor="middle"')+text((left+right)/2,372,format(size[a]),'text-anchor="middle"');
    markup+=line(right+7,top,x+7,top)+line(right+7,bottom,x+7,bottom)+line(x,top,x,bottom);
    markup+=`<path d="M${x-3},${top+7}L${x},${top}L${x+3},${top+7} M${x-3},${bottom-7}L${x},${bottom}L${x+3},${bottom-7}" fill="none" stroke="#628093"/>`;
    markup+=`<g transform="translate(440 ${(top+bottom)/2}) rotate(-90)">${text(0,0,t(view.labels[1]),'text-anchor="middle"')}${text(0,20,format(size[b]),'text-anchor="middle"')}</g>`;
    return markup;
  };
  const svg=(inner,label)=>`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 490 400" role="img" aria-label="${esc(label)}"><rect width="490" height="400" fill="white"/>${inner}</svg>`;
  const baseMarkup=measurement=>{
    const b=measurement.base,scale=225/b.size,half=b.size*scale/2,cx=215,cy=175;
    let content=text(24,28,t('drawing_base'),'font-weight="700"')+text(24,50,measurement.mountSku);
    content+=b.shape==='round'?`<circle cx="${cx}" cy="${cy}" r="${half}" fill="#f4f7f9" stroke="#284c60"/>`:`<rect x="${cx-half}" y="${cy-half}" width="${half*2}" height="${half*2}" rx="7" fill="#f4f7f9" stroke="#284c60"/>`;
    b.holes.forEach(([x,z])=>{const px=cx+z*scale,py=cy-x*scale;content+=`<circle cx="${px}" cy="${py}" r="${b.holeDiameter*scale/2}" fill="white" stroke="#284c60"/>`+line(px-7,py,px+7,py)+line(px,py-7,px,py+7);});
    const opening=b.cableOpening;
    if(opening?.status==='measured'){
      const [ox,oz]=opening.center,px=cx+oz*scale,py=cy-ox*scale;
      const title=`<title>${esc(t('drawing_cable_opening'))}</title>`;
      content+=opening.shape==='circle'?`<circle data-cable-cutout="" cx="${px}" cy="${py}" r="${opening.diameter*scale/2}" fill="#e8f5fa" stroke="#086591" stroke-width="1.5">${title}</circle>`:`<path data-cable-cutout="" d="${opening.path}" transform="matrix(0 ${-scale} ${scale} 0 ${cx} ${cy})" fill="#e8f5fa" stroke="#086591" stroke-width="1.5" vector-effect="non-scaling-stroke">${title}</path>`;
      const width=opening.width*scale,left=px-width/2,right=px+width/2;
      content+=line(left,py,right,py,'#086591')+`<path d="M${left+5},${py-3}L${left},${py}L${left+5},${py+3} M${right-5},${py-3}L${right},${py}L${right-5},${py+3}" stroke="#086591" fill="none"/>`;
      content+=text(px,py-8,opening.shape==='circle'?'D':'W','text-anchor="middle" font-weight="700"');
      if(opening.shape!=='circle'){
        const length=opening.length*scale,y1=cy-opening.bounds[2]*scale,y2=cy-opening.bounds[0]*scale,x=px-10;
        content+=line(x,y1,x,y2,'#086591')+`<path d="M${x-3},${y1+5}L${x},${y1}L${x+3},${y1+5} M${x-3},${y2-5}L${x},${y2}L${x+3},${y2-5}" stroke="#086591" fill="none"/>`+text(x-8,py+22,'L','text-anchor="end" font-weight="700"');
      }
    }else if(opening){
      content+=`<ellipse data-cable-cutout-pending="" cx="${cx}" cy="${cy}" rx="27" ry="53" fill="#fff8e8" stroke="#a57722" stroke-dasharray="5 3"><title>${esc(t('drawing_cable_schematic'))}</title></ellipse>`;
      content+=text(cx,cy+76,t('drawing_cable_schematic'),'text-anchor="middle"');
    }
    if(Number.isFinite(b.spacing)&&b.holes.length){
      const d=b.spacing*scale/2,x=cx+half+30,y=cy+half+26;
      content+=line(cx-d,cy+d,cx-d,y+6)+line(cx+d,cy+d,cx+d,y+6)+line(cx-d,y,cx+d,y);
      content+=text(cx,y+20,format(b.spacing),'text-anchor="middle"');
      content+=line(cx+d,cy-d,x+6,cy-d)+line(cx+d,cy+d,x+6,cy+d)+line(x,cy-d,x,cy+d);
      content+=`<g transform="translate(${x+20} ${cy}) rotate(-90)">${text(0,0,format(b.spacing),'text-anchor="middle"')}</g>`;
      content+=text(24,365,t('drawing_hole_pattern')+' · '+b.holes.length+' '+t('drawing_holes'));
    }
    content+=text(24,388,t(b.shape==='round'?'drawing_round':'drawing_square')+': '+format(b.size));
    return content;
  };
  const installationRows=m=>{
    const rows=[];
    if(m.base){rows.push([t('drawing_base_size'),t(m.base.shape==='round'?'drawing_round':'drawing_square')+' · '+format(m.base.size)]);if(Number.isFinite(m.base.spacing)&&m.base.holes.length){rows.push([t('drawing_hole_pattern'),format(m.base.spacing)+' × '+format(m.base.spacing)]);if(m.base.holes.length===6)rows.push([t('drawing_step'),format(m.base.spacing/2)]);}}
    const opening=m.base?.cableOpening;
    if(opening?.status==='measured'){
      if(opening.shape==='circle')rows.push([t('drawing_cable_diameter'),format(opening.diameter)]);
      else rows.push([t('drawing_cable_width'),format(opening.width)],[t('drawing_cable_length'),format(opening.length)]);
    }else if(m.base?.cableOpening)rows.push([t('drawing_cable_opening'),t('drawing_cable_pending')]);
    m.platforms.forEach((p,i)=>rows.push(['H'+(i+1)+' · '+t(p.key),format(p.height)]));
    if(selected.some(([role])=>role==='plate')&&!m.platforms.some(p=>p.key==='drawing_upper_height'))rows.push([t('drawing_upper_height'),t('drawing_height_pending')]);
    return rows;
  };
  const refresh=async()=>{
    const token=++serial;
    current=null;el('drawing-save').disabled=true;el('drawing-print').disabled=true;
    el('drawing-views').innerHTML='';el('drawing-summary').innerHTML='';el('drawing-installation').innerHTML='';el('drawing-missing').textContent='';el('drawing-missing').hidden=true;
    el('drawing-parts').textContent=selected.map(([,v])=>v.sku+(v.shortDescription?' · '+v.shortDescription:'')).join('\n');
    el('drawing-status').textContent=selected.length?t('drawing_loading'):t('drawing_empty');
    el('drawing-retry').hidden=true;
    el('drawing-proxy').hidden=true;
    if(!selected.length)return;
    try{
      await load();if(token!==serial)return;
      const measurement=measureMountDrawing(selected,connections,data,category);
      el('drawing-proxy').hidden=!measurement.representative;
      if(measurement.pending.length){
        el('drawing-missing').textContent=t('drawing_missing')+' '+measurement.pending.map(([,v])=>label(v)).join(', ');
        el('drawing-missing').hidden=false;
      }
      if(!measurement.placed.length&&!measurement.base){el('drawing-status').textContent=t('drawing_unavailable');return;}
      current=measurement;
      el('drawing-status').textContent=t(measurement.complete?'drawing_complete':'drawing_partial');
      el('drawing-summary').innerHTML=measurement.placed.length?[[1,'dimension_height'],[2,'dimension_width'],[0,'dimension_depth']].map(([axis,key])=>`<div><dt>${esc(t(key))}</dt><dd>${esc(format(measurement.size[axis]))}</dd></div>`).join(''):'';
      el('drawing-installation').innerHTML=installationRows(measurement).map(([label,value])=>`<div><dt>${esc(label)}</dt><dd>${esc(value)}</dd></div>`).join('');
      el('drawing-views').innerHTML=(measurement.placed.length?views.map(view=>`<div class="mb-drawing-view">${svg(viewMarkup(measurement,view),t('drawing_'+view.key))}</div>`).join(''):'')+(measurement.base?`<div class="mb-drawing-view">${svg(baseMarkup(measurement),t('drawing_base'))}</div>`:'');
      el('drawing-save').disabled=false;el('drawing-print').disabled=false;
    }catch(error){if(token!==serial)return;el('drawing-status').textContent=t('drawing_error');el('drawing-retry').hidden=false;}
  };
  const exportMarkup=()=>{
    if(!current)return;
    const wrap=line=>String(line).match(/.{1,44}(?:\s|$)|\S{1,44}/g)?.map(s=>s.trim())||[''];
    const notes=[{value:t(current.complete?'drawing_complete':'drawing_partial'),bold:true},{value:t('drawing_base_datum')}];
    installationRows(current).filter(([key])=>/^H\d+ · /.test(key)||['drawing_step','drawing_upper_height','drawing_cable_opening','drawing_cable_diameter','drawing_cable_width','drawing_cable_length'].some(k=>key===t(k))).forEach(([key,value])=>notes.push({value:key,bold:true},{value}));
    if(current.base)notes.push({value:t('drawing_cable_scope')});
    notes.push({value:t('drawing_parts'),bold:true});
    selected.forEach(([,v])=>notes.push({value:v.sku,bold:true},{value:v.shortDescription||''}));
    if(current.pending.length)notes.push({value:t('drawing_omitted'),bold:true},...current.pending.map(([,v])=>({value:label(v)})));
    if(current.representative)notes.push({value:t('floodlight_geometry_note')});
    const lines=notes.flatMap(n=>wrap(n.value).map(value=>({...n,value}))),leading=Math.min(17,652/Math.max(lines.length,1)),size=Math.min(14,leading*.82);
    const view=markup=>markup.replace(/font-size="13"/g,'font-size="17"');
    const panels=current.placed.length?views.map((v,i)=>`<g transform="translate(${i===1?388:20} ${i===2?397:72}) scale(.76)">${view(viewMarkup(current,v))}</g>`).join(''):'';
    const base=current.base?`<g transform="translate(388 397) scale(.76)">${view(baseMarkup(current))}</g>`:'';
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1100 790" width="1100" height="790"><rect width="1100" height="790" fill="white"/>${text(30,35,'SEAVIEW · '+t('drawing_title'),'font-weight="700"').replace('font-size="13"','font-size="24"')}${text(30,58,t('drawing_print_layout'))}${panels}${base}<path d="M755 72V738" stroke="#d0dce3"/>${lines.map((n,i)=>text(774,88+i*leading,n.value,n.bold?'font-weight="700"':'').replace('font-size="13"',`font-size="${size.toFixed(2)}"`)).join('')}${text(30,766,t('drawing_print_reference'))}</svg>`;
  };
  const exportDrawing=()=>{
    const content=exportMarkup();if(!content)return;
    const url=URL.createObjectURL(new Blob([content],{type:'image/svg+xml'}));
    const a=document.createElement('a');a.href=url;a.download='Seaview-'+(selected.find(([role])=>role==='mount')?.[1].sku||'mount')+'-dimensions.svg';a.hidden=true;dialog.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),30000);
  };
  const close=()=>{serial++;dialog.close();trigger.focus();};
  trigger.addEventListener('click',()=>{dialog.showModal();refresh();});
  el('drawing-close').addEventListener('click',close);
  el('drawing-retry').addEventListener('click',refresh);
  el('drawing-save').addEventListener('click',exportDrawing);
  let afterPrint=()=>{};
  el('drawing-print').addEventListener('click',()=>{
    const content=exportMarkup();if(!content)return;
    afterPrint();afterPrint=printMountSvg(content,t('drawing_title'));
  });
  dialog.addEventListener('close',()=>{serial++;afterPrint();});
  return {update(parts){
    const nextCategory=el('category').value,next=JSON.stringify([parts.map(([role,v])=>[role,v.sku,v.quantity||1]),nextCategory]);
    selected=parts;category=nextCategory;trigger.disabled=!parts.length;
    if(next===signature)return;signature=next;if(dialog.open)refresh();
  },destroy(){serial++;afterPrint();if(dialog.open)dialog.close();}};
};

  const start = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = applyBuilderCatalogRevisions(JSON.parse(root.querySelector('[data-catalog]').textContent).concat(JSON.parse(root.querySelector('[data-tapered-catalog]').textContent)||[])).filter(p => p && p.variants);
    const T = JSON.parse(root.querySelector('[data-translations]').textContent);
    const grid = createCompatibilityGrid(JSON.parse(root.querySelector('[data-compatibility]').textContent));
    const t = key => T[key] || key;
    const $ = name => root.querySelector(`[data-${name}]`);
    const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency',currency:root.dataset.currency || 'USD' }).format(n/100);
    const baseSku = s => s.replace(/BLK/g,'');
    const color = v => /BLK|Black/i.test(v.sku + ' ' + v.title) ? 'black' : /Stainless Steel/i.test(v.title) ? 'steel' : 'white';
    const product = h => data.find(p => p.handle === h);
    const variants = h => (product(h)?.variants || []).filter(v => v.sku).map(v => ({...v,handle:h,color:color(v),options:v.options || [v.option1,v.option2,v.option3].filter(Boolean),price:Number(v.price),image:v.featured_image?.src || (product(h).variants.length===1?(product(h).featured_image || product(h).images?.[0] || ''):''),imageExample:false}));
    const byId = new Map();
    data.forEach(p => variants(p.handle).forEach(v => byId.set(String(v.id),v)));
    const uniq = (a, key) => [...new Map(a.map(v => [key(v),v])).values()];
    const knownBases = {PMA57M1:7,PMA107M1:7,PMA167M1:7,PMA247M1:7,PMA3610M1:10,PMF57M1:7,PMF107M1:7,AM5M1:8,AM12M1:8,AM18M1:8,PMA1210M2:10,PMA1810M2:10,PMADM1M2:10,PMADM124M2:10,PMADM2M2:10,PMADM3M1:10,PMADM4M1:10};
    const mountVariants = ['modular-radar-mounts','modular-satdome-mounts','modular-open-array-radar-mounts','modular-dual-mounts'].flatMap(variants).filter(v => /M[12](BLK)?$/.test(v.sku) && !v.sku.includes('+')).filter((v,i,a)=>a.findIndex(x=>x.sku===v.sku)===i).map(v => {
      const b=baseSku(v.sku), dual=b.includes('DM'), style=dual?'dual':b.startsWith('PMF')?'forward':b.startsWith('AM')?'vertical':'aft';
      const height=dual?({PMADM1M2:13.25,PMADM124M2:33,PMADM2M2:23.75,PMADM3M1:27.99,PMADM4M1:19}[b]):Number(v.options[1]) || Number((b.match(/(?:PMA|PMF|AM)(\d+?)(?:7|10)?M/)||[])[1]);
      const family=/M2$/.test(b)?'M2':'M1';
      return {...v,b,dual,style,height,family,base:knownBases[b],label:`${height}" ${t(style)}${dual?'':' '+t('mount')}`, imageExample:/Intellian|PMA-247/i.test(v.image) || b==='PMA3610M1'};
    });
    const stainlessPhoto=variants('modular-open-array-radar-mounts').find(v=>v.sku==='PMA57LSS')?.image;
    const stainlessMounts=variants('stainless-steel-mounts').filter(v=>/^PMA57LSS(?:\+ADAHALO3)?$/.test(v.sku)&&v.options[2]==='No light bar').map(v=>({...v,image:stainlessPhoto||v.image||product('stainless-steel-mounts').featured_image,color:'steel',stainless:true,b:'PMA57LSS',family:'SS',dual:false,style:'aft',height:5,base:7,brand:v.options[0],model:v.options[1],category:/open array|TX06S|TX10S/i.test(v.options[1])?'open':'dome',label:'5" '+t('aft')+' '+t('mount')}));
    const taperedMounts=variants('tapered-masts').filter(v=>['PMA100SV2','PMABC37SV2','PMA200V2','PMA200V3'].includes(v.sku)).map(v=>({...v,tapered:true,b:v.sku,color:'white',family:'TAPERED',brand:'Seaview',category:/^PMA200V[23]$/.test(v.sku)?'open':'dome',model:t(/^PMA200V[23]$/.test(v.sku)?'tapered_open':'tapered_dome'),label:t(['PMABC37SV2','PMA200V3'].includes(v.sku)?'tapered_camera':'tapered_standard'),image:v.image||product('tapered-masts').featured_image||product('tapered-masts').images?.[0]||'',imageExample:!v.image}));
    const cameraDedicatedMounts=['aft-leaning-mounts','vertical-mounts'].flatMap(variants).map(v=>{
      const parts=String(v.title||'').split(' / '),brand=parts.shift()||'',height=/\/(?:\s*)(?:5|12)$/.test(v.title||'')?parts.pop():'';
      const rawModel=parts.join(' / ');
      // Finish-specific Nightwave titles describe the same electronics model.
      // Keep finish as the Step 2 mount choice rather than duplicating the model.
      const model=/^Sionyx$/i.test(brand)&&/^Nightwave\b/i.test(rawModel)?'Nightwave':rawModel;
      return {...v,brand,model,style:v.handle==='vertical-mounts'?t('vertical'):t('aft'),height,dedicated:true};
    });
    const plateVariants=variants('modular-top-plates').filter(v => v.sku!=='ADAGMT'&&!/^ADAC700/.test(v.sku)).map(v => ({...v,brand:v.options[0],model:v.options[1],family:/^M1 or M2/.test(v.options[2]||'')?['M1','M2']:[(v.options[2]||'').startsWith('M2')?'M2':'M1']})).flatMap(v=>{
      // Split the catalog's broad dome groups into explicit builder choices.
      // Jason's required-plate rule uses the existing brand/finish variant;
      // no new Shopify product or variant is created.
      const special=v.brand==='Garmin'&&/FANTOM24\(x\)/i.test(v.model)?{
        model:'Fantom 24 / 24x',other:v.model.split(',').map(s=>s.trim()).filter(s=>!/^FANTOM24\(x\)$/i.test(s)).join(', ')
      }:v.brand==='Raymarine'&&v.model==='18" - 24" Closed Dome Radars'?{
        model:'RD424',other:'Other 18" - 24" closed dome radars (excluding RD424)'
      }:null;
      if(!special)return [v];
      const choices=[{...v,model:special.other,radarChoice:true}];
      if(baseSku(v.sku)==='ADAR1DMLTB')choices.push({...v,model:special.model,family:['M1','M2'],radarChoice:true,radarSize:'24',requiredPlate:true});
      return choices;
    });
    [['starlink-mini-modular-top-plate','Mini'],['starlink-standard-mount-gen-3-standard-modular-top-plate','Standard'],['starlink-performance-gen3-modular-top-plate','Performance Gen3']].forEach(([h,model])=>variants(h).forEach(v=>plateVariants.push({...v,brand:'Starlink',model,family:['M1','M2']})));
    const pma200v3Nav=variants('tapered-masts').find(v=>v.sku==='PMA200V3+LTBLED12C5');
    const starlinkModelOrder=['Mini','Standard','Performance Gen3','Performance Gen2 (formerly Flat HP)'];
    plateVariants.forEach(v=>{if(v.brand==='Starlink'&&v.model==='Flat High Performance')v.model='Performance Gen2 (formerly Flat HP)';});
    const plateCategory = v => v.brand==='Starlink'?'starlink':/^ADAF|^ADABLANK/.test(v.sku)?'camera':/open array/i.test(v.model)?'open':/radar/i.test(v.model)||/^ADAR/.test(v.sku)&&!/^SCX20$/.test(v.model)?'dome':'sat';
    const openArrayModels=uniq(plateVariants.filter(v=>plateCategory(v)==='open'),v=>`${v.brand}|${v.model}|${v.color}`);
    openArrayModels.forEach(target=>{
      if(plateVariants.some(v=>v.brand===target.brand&&v.model===target.model&&v.color===target.color&&baseSku(v.sku)==='ADAR1DMLTB'))return;
      const matchingPlate=plateVariants.find(v=>v.color===target.color&&baseSku(v.sku)==='ADAR1DMLTB'&&v.brand===target.brand)||plateVariants.find(v=>v.color===target.color&&baseSku(v.sku)==='ADAR1DMLTB');
      if(matchingPlate)plateVariants.push({...matchingPlate,brand:target.brand,model:target.model,family:['M2'],requiredPlate:true,openArrayM2:true});
    });
    const bars=variants('light-bars').filter(v=>v.options[1]==='No light'&&!v.sku.includes('+'));
    const tops=variants('light-bar-tops');
    const spreaders=variants('spreader-kits').filter(v=>/^SP[12]MOD/.test(v.sku));
    const wedges=variants('base-wedges');
    const starlinkWedges=variants('starlink-flat-high-performance-white-wedge-base');
    const hinges=[...variants('hinge-adapter'),...variants('svehb1-electrically-actuated-hinge')];
    const removables=variants('quick-release-removable-bases');
    const folds=variants('fold-over-light-bar-kit');
    const floodlights=[1,2].map(quantity=>({id:'SPLTLEDV3-'+quantity,sku:'SPLTLEDV3',quantity,price:20000,options:[],color:'white',handle:'fog-light-kits',title:t('floodlight'),image:'',available:false,availabilityUnknown:true,draftReplacement:true}));
    const describe=(v,role)=>{
      const b=baseSku(v.sku).split('+')[0];
      if(role==='mount')return v.tapered?t('tapered')+' · '+v.model+' · '+v.label:v.stainless?v.label+' · '+t('steel')+' · '+t('steel_plate_included')+(v.sku.includes('+ADAHALO3')?' · ADAHALO3':''):v.dedicated?t('complete_mount')+' · '+v.style+(v.height?' '+v.height+'″':''):mountVariants.find(m=>m.sku===v.sku)?.label||t('mount');
      const key={ADAR1:'desc_radar',ADAR1DMLTB:'desc_radar_clearance',ADABLANK:'desc_blank',ADAF1:'desc_camera',ADAF2:'desc_camera',ADAF3:'desc_camera',ADAS1:'desc_satellite',ADAS2:'desc_satellite',ADAMINI:'desc_mini',ADAG3:'desc_standard',ADASPG3:'desc_performance'}[b];
      if(role==='plate')return key?t(key):t('plate');
      if(role==='floodlight')return t(v.quantity===2?'floodlight_two':'floodlight_one');
      if(role==='spreader')return t('spreader')+', '+(v.options[1]||'');
      if(role==='top')return v.title.replace(/ - \(#.*$/,'').replace(/^(White|Black) /i,'');
      if(role==='bar')return t('bar')+' ('+v.options[0].replace(/^For /,'')+')';
      if(role==='starlink_wedge')return t('starlink_wedge_description');
      if(role==='wedge')return /^SVSLWB/.test(v.sku)?t('starlink_wedge_description'):v.options[0]+' '+t('wedge');
      return t(role);
    };
    const state={setup:'single',category:'dome',brand:'Garmin',model:'',finish:'white',size:'24',lower:'dome',cameraStyle:'light-bar',mount:'',plate:'',bar:'',top:'',spreader:'',floodlight:'','mast-nav':'',wedge:'','starlink-wedge':'',hinge:'',removable:'',fold:'',focus:'mount'};
    const finishWrap=$('finish-wrap');
    const finishHome=finishWrap.parentElement;
    const finishNextSibling=finishWrap.nextSibling;
    const savedKeys=['setup','category','brand','model','finish','size','lower','cameraStyle','mount','plate','bar','top','spreader','floodlight','mast-nav','wedge','starlink-wedge','hinge','removable','fold'];
    try {const raw=new URLSearchParams(location.hash.slice(1)).get('build');if(raw){const s=JSON.parse(raw);for(const k of savedKeys)if(typeof s[k]==='string'&&s[k].length<350)state[k]=s[k];}} catch {}
    if(!['single','dual','tapered'].includes(state.setup))state.setup='single';
    if(!['dome','open','sat','starlink','camera'].includes(state.category))state.category='dome';
    if(!['white','black','steel'].includes(state.finish))state.finish='white';
    if(/^ADAC700/.test(byId.get(state.plate)?.sku||'')||/\bc700\b/i.test(state.model)){
      state.model='';state.mount='__none__';state.plate='__none__';
      for(const key of ['bar','top','spreader','floodlight','mast-nav','wedge','starlink-wedge','hinge','removable','fold'])state[key]='';
    }
    let visible={},selected=[],warnings=[],complete=false;
    let clearPrint=()=>{};
    root.addEventListener('shopify:section:unload',()=>clearPrint(),{once:true});
    const select = (key, arr, label, optional=false) => {
      const el=$(key); if(!el)return;
      const id=v=>String(v.id??v.value);
      const before=state[key];
      const omitted=['mount','plate'].includes(key)&&state[key]==='__none__';
      if(!omitted&&!arr.some(v=>id(v)===state[key]))state[key]=optional?'':id(arr[0]||{value:''});
      el.innerHTML=(omitted?`<option value="__none__">${esc(t('choose_again'))}</option>`:'')+(optional?`<option value="">${esc(t('none'))}</option>`:'')+arr.map(v=>`<option value="${esc(id(v))}">${esc(label(v))}</option>`).join('');
      if(!arr.length&&!optional)el.innerHTML=`<option value="">${esc(t('no_options'))}</option>`;
      el.value=state[key];el.disabled=!arr.length;
      visible[key]=arr;
      return before && before!==state[key];
    };
    const canMount = m => {
      if(m.color!==state.finish || m.dual!==(state.setup==='dual'))return false;
      if(state.setup==='dual'){
        if(state.lower==='open'&&!['PMADM2M2','PMADM3M1'].includes(m.b))return false;
        if(state.lower==='dome'&&!['PMADM1M2','PMADM124M2','PMADM4M1'].includes(m.b))return false;
        if(state.category==='sat'&&Number(state.size)>18&&['PMADM3M1','PMADM4M1','PMADM124M2'].includes(m.b))return false;
        if(state.category==='sat'&&Number(state.size)>24)return false;
      }else{
        if(state.category==='open'&&!(m.style!=='vertical'&&m.height===5||['PMA1210M2','PMA1810M2'].includes(m.b)))return false;
        if(state.category==='sat'&&Number(state.size)>(m.style==='vertical'||m.family==='M2'?24:16))return false;
        if(state.category==='dome'&&Number(state.size)>24)return false;
      }
      return true;
    };
    const barLabel = b => `${b.sku} · ${b.options[0].replace(/^[A-Z0-9]+\s*[-–]?\s*/,'')}`;
    const fitBars = (m,p,rows) => {
      if(m?.stainless)return state.category==='dome'?bars.filter(v=>v.sku==='LTBRSS'):[];
      if(!m||!p||baseSku(p.sku).startsWith('ADASTLKA'))return [];
      let allowed=[];
      if(state.category==='dome')allowed=['LTBR','LTBRSS','LTBSF4','LTBSF5'];
      if(state.category==='open')allowed=Number(state.size)>4.5?['LTBOA6']:['LTBOA','LTBOA6'];
      if(state.category==='sat')allowed=Number(state.size)>20?['LTBS24']:['LTBS','LTBS24'];
      if(state.category==='camera')allowed=/M300C|M332|M364/i.test(state.model)?['LTBSF3']:['LTB13','LTBSF2','LTBSF5'];
      if(state.category==='starlink')allowed=['LTBR'];
      // Preserve size/usage limits when a plate serves several electronics
      // types. For covered parts, the sheet supplies the actual accessory list.
      let use=allowed;
      if(rows!==null){
        if(state.category==='sat'&&Number(state.size)<=20)use=['LTBS','LTBS24','LTBSF2'];
        if(state.category==='camera')use=['LTB13','LTBS','LTBSF2','LTBSF4','LTBSF5'];
        if(state.category==='starlink')use=['LTBR','LTBSF4'];
      }
      return bars.filter(v=>{
        const sku=baseSku(v.sku),choices=grid.listed('bar',sku)?use:allowed;
        return sku!=='LTBRSS'&&choices.includes(sku)&&v.color===state.finish&&grid.allows(rows,'bar',v.sku);
      });
    };
    const get = k => (visible[k]||[]).find(v=>String(v.id)===state[k]);
    const cartBlockedForOrdering = () => selected.some(([,v])=>v.draftReplacement||v.available===false||!Number.isSafeInteger(Number(v.id)));
    const orderingNote = () => {
      if(root.dataset.orderingEnabled!=='true')return t('draft_ordering');
      if(!complete)return t('cart_incomplete');
      if(cartBlockedForOrdering())return t('cart_unavailable');
      return t('ordering_enabled');
    };
    const partsText = () => [t('heading'),complete?t('matched_status'):t('incomplete_status'),`${t(state.setup)} | ${state.brand} | ${state.model}`, ...selected.map(([key,v])=>`${t(key)}: ${v.sku} | ${v.quantity||1} × ${money(v.price)} | ${v.shortDescription}`),`${t('subtotal')}: ${money(selected.reduce((n,[,v])=>n+v.price*(v.quantity||1),0))}`, ...warnings.map(w=>t('review')+': '+w),...(selected.some(([,v])=>v.draftReplacement)?[t('replacement_price_note')]:[]),orderingNote()].join('\n');
    const safeURL = raw => { const u=new URL(raw,location.origin==='null'?root.dataset.shop:location.origin);for(const [k,v] of [...u.searchParams])if(/chatgpt|openai/i.test(v)&&/^utm_|^ref$/i.test(k))u.searchParams.delete(k);return u; };
    const draftURL = raw => {const u=safeURL(raw);if(root.dataset.previewTheme)u.searchParams.set('preview_theme_id',root.dataset.previewTheme);return u;};
    const buildURL = () => {const u=draftURL(location.href.startsWith('file:')?root.dataset.shop+'/pages/mount-selection-guide':location.href);u.hash=new URLSearchParams({build:JSON.stringify(Object.fromEntries(savedKeys.map(k=>[k,state[k]])))}).toString();return u;};
    const emailContent = () => mountPartsEmailContent(selected,[t(state.setup),state.brand,state.model].filter(Boolean).join(' · '),[
      ...(!complete?[t('cart_incomplete')]:[]),
      ...warnings.map(w=>t('review')+': '+w),
      ...(selected.some(([,v])=>v.draftReplacement)?[t('replacement_price_note')]:[]),
      t('price_note')
    ],buildURL().href,t,esc,money);
    $('email-dialog').addEventListener('close',()=>{
      const returnToBuild=$('email-dialog').returnValue==='build';
      $('email-dialog').returnValue='';
      const target=returnToBuild&&!$('cart').disabled?$('cart'):$('email');
      target.focus({preventScroll:returnToBuild});
      if(returnToBuild)root.querySelector('.mb-bom').scrollIntoView({behavior:'smooth',block:'center'});
    });
    $('email-preview').addEventListener('click',event=>{
      const link=event.target.closest('a[href]');
      if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||link.href!==buildURL().href)return;
      event.preventDefault();
      history.replaceState(null,'',link.href);
      $('email-dialog').close('build');
    });
    const mountEmailSetup = false;
    let emailSending=false;
    const emailEndpoint='https://hook.us2.make.com/so4dmj7qrtbpzmvl1ib2e04t5b2zjsve';
    root.querySelector('.mb-email-instructions').textContent=t(mountEmailSetup?'email_setup_instructions':'email_direct_instructions');
    root.querySelector('.mb-email-note').textContent=t('email_direct_note');
    $('email-send').textContent=t(mountEmailSetup?'email_setup_submit':'email_send');
    $('email-form').addEventListener('submit',async event=>{
      event.preventDefault();
      if(emailSending||!selected.length||!$('email-form').reportValidity())return;
      const recipient=$('email-recipient').value.trim();
      const content=emailContent();
      const publicURL=buildURL();publicURL.searchParams.delete('preview_theme_id');publicURL.searchParams.delete('_fd');publicURL.searchParams.delete('pb');
      const payload=new URLSearchParams({
        recipient,
        subject:t('email_subject'),
        html:content.html.replaceAll(esc(buildURL().href),esc(publicURL.href)),
        build_url:publicURL.href,
        source:'seaview-mount-builder',
        request_id:crypto.randomUUID(),
        setup_sample:mountEmailSetup?'true':'false'
      });
      emailSending=true;$('email-send').disabled=true;$('email-result').textContent=t('email_sending');
      const controller=new AbortController();const timer=setTimeout(()=>controller.abort(),45000);
      try{
        const response=await fetch(emailEndpoint,{method:'POST',body:payload,signal:controller.signal});
        if(!response.ok)throw new Error('email-request-failed');
        if(mountEmailSetup){
          $('email-result').textContent=t('email_setup_captured');
        }else{
          const result=await response.json();
          if(result.sent!==true)throw new Error('email-unconfirmed');
          $('email-result').textContent=t('email_sent');
        }
      }catch{
        $('email-result').textContent=t('email_send_error');
      }finally{
        clearTimeout(timer);emailSending=false;$('email-send').disabled=false;
      }
    });

    const cleanLocation = () => {const u=draftURL(location.href);if(u.href!==location.href)history.replaceState(null,'',u);};
    const imageURL = v => {
      if(!v.image)return '';
      try{const u=safeURL(v.image);u.searchParams.set('width','900');return u.href;}catch{return '';}
    };
    const link = v => `${root.dataset.shop || ''}/products/${encodeURIComponent(v.handle)}${v.draftReplacement?'':'?variant='+v.id}`;
    const media = (v,cls='') => v.image?`<img class="${cls}" src="${esc(imageURL(v))}" alt="${esc(v.sku)}" loading="lazy" width="700" height="700">`:`<span class="mb-missing">${esc(t('image_pending'))}</span>`;
    const viewer=createMountViewer(root,t,esc,media);
    const drawing=createMountDrawing(root,t,esc);
    root.addEventListener('shopify:section:unload',()=>viewer.destroy(),{once:true});
    root.addEventListener('shopify:section:unload',()=>drawing.destroy(),{once:true});
    function render() {
      warnings=[];
      const tapered=state.setup==='tapered';
      if(tapered){state.finish='white';if(!['dome','open'].includes(state.category))state.category='dome';}
      if(state.setup==='dual'&&state.finish==='steel')state.finish='white';
      const stainless=state.finish==='steel';
      if(stainless&&!['dome','open'].includes(state.category)){state.category='dome';state.brand='Garmin';state.model='';}
      select('finish',(state.setup==='single'?['white','black','steel']:['white','black']).map(value=>({value})),v=>t(v.value));
      const noLightBar=!tapered&&state.category==='camera'&&state.cameraStyle==='no-light-bar',integratedMount=noLightBar||stainless||tapered;
      if(noLightBar)state.setup='single';
      if(state.setup==='dual'&&['dome','open'].includes(state.category))state.category='starlink';
      $('setup').value=state.setup;$('category').value=state.category;$('finish').value=state.finish;$('lower').value=state.lower;
      $('setup').closest('label').hidden=noLightBar;
      // In the dedicated-mount flow finish selects the completed mount, so it
      // belongs beside that choice in Step 2 rather than under electronics.
      if(noLightBar)$('finish-step-two').appendChild(finishWrap);
      else finishHome.insertBefore(finishWrap,finishNextSibling);
      finishWrap.hidden=tapered;
      $('brand').closest('label').hidden=tapered;$('model').closest('label').hidden=tapered;
      for(const o of $('category').options)o.disabled=state.setup==='dual'&&['dome','open'].includes(o.value)||(stainless||tapered)&&!['dome','open'].includes(o.value);
      $('lower-wrap').hidden=state.setup!=='dual';
      $('camera-style-wrap').hidden=state.category!=='camera';
      if(state.category==='camera')$('camera-style').value=state.cameraStyle;
      $('size-wrap').hidden=!['dome','open','sat'].includes(state.category);
      const sizes=state.category==='open'?(stainless?['4']:tapered?['4','4.5']:['4','4.5','6']):state.category==='sat'?['16','18','20','24','26']:['18','24'];
      select('size',sizes.map(v=>({value:v})),v=>`${t('up_to')} ${v.value}${state.category==='open'?"'":'"'}`);
      const categoryPlates=tapered?taperedMounts.filter(v=>v.category===state.category):stainless?stainlessMounts.filter(v=>v.category===state.category):noLightBar?cameraDedicatedMounts:plateVariants.filter(v=>plateCategory(v)===state.category&&v.color===state.finish);
      select('brand',uniq(categoryPlates,v=>v.brand).map(v=>({value:v.brand})).sort((a,b)=>a.value.localeCompare(b.value)),v=>v.value);
      const brandPlates=categoryPlates.filter(v=>v.brand===state.brand);
      const sionyxNightwave=state.brand==='Sionyx'&&brandPlates.some(v=>/^Nightwave(?: D1)?$/i.test(String(v.model||'')));
      const modelOptions=sionyxNightwave
        ?[{value:'Nightwave Digital'},{value:'Nightwave Analog'}]
        :state.brand==='Starlink'
          ?starlinkModelOrder.filter(model=>brandPlates.some(v=>v.model===model)).map(value=>({value}))
          :uniq(brandPlates,v=>v.model).sort((a,b)=>Number(!!b.requiredPlate)-Number(!!a.requiredPlate)).map(v=>({value:v.model}));
      // A broad legacy model string cannot identify the customer's radar.
      // Require a choice for these manufacturers instead of restoring ADAR1.
      if(brandPlates.some(v=>v.radarChoice))modelOptions.unshift({value:'',label:t('choose_radar_model')});
      select('model',modelOptions,v=>v.label||v.value);
      const models=categoryPlates.filter(v=>v.brand===state.brand&&(sionyxNightwave&&/^Nightwave(?: D1)?$/i.test(String(v.model||''))||!sionyxNightwave&&v.model===state.model));
      const radarSize=models.find(v=>v.radarSize)?.radarSize;
      if(radarSize){state.size=radarSize;$('size').value=radarSize;$('size').disabled=true;}
      const compatibleMounts=(stainless||tapered)?models:noLightBar?models.filter(v=>v.color===state.finish):mountVariants.filter(canMount).filter(m=>models.some(p=>p.family.includes(m.family)&&grid.pairAllowed(state.setup,m.sku,p.sku)));
      select('mount',compatibleMounts,v=>tapered?`${v.sku} · ${v.label} · ${money(v.price)}`:stainless?`PMA57LSS · ${v.label} · ${t('steel')}${v.sku.includes('+ADAHALO3')?' + ADAHALO3':''} · ${money(v.price)}`:noLightBar?`${v.sku} · ${v.style}${v.height?' · '+v.height+'″':''} · ${money(v.price)}`:`${v.sku} · ${v.label} · ${money(v.price)}`);
      const m=get('mount');
      const hasMastNav=tapered&&m?.sku==='PMA200V3'&&pma200v3Nav;
      $('mast-nav-wrap').hidden=!hasMastNav;
      select('mast-nav',hasMastNav?[{value:'led'}]:[],()=>t('mast_nav_add')+' · +'+money(pma200v3Nav.price-m.price),true);
      const selectedMast=hasMastNav&&state['mast-nav']==='led'?{...m,...pma200v3Nav,tapered:true,model:m.model,label:m.label+' · '+t('mast_nav_included')}:m;

      const requiresOpenArrayM2Plate=state.category==='open'&&m&&['PMA1210M2','PMA1810M2'].includes(m.b);
      select('plate',integratedMount?[]:uniq(models.filter(v=>m&&v.family.includes(m.family)&&grid.pairAllowed(state.setup,m.sku,v.sku)&&(!requiresOpenArrayM2Plate||baseSku(v.sku)==='ADAR1DMLTB')),v=>v.sku),v=>`${v.sku} · ${describe(v,'plate')} · ${money(v.price)}`);
      const p=get('plate');
      $('plate-wrap').hidden=integratedMount;
      $('accessories-step').hidden=noLightBar;
      $('bar').closest('label').hidden=tapered;
      $('spreader').closest('label').hidden=tapered;
      $('install-options').hidden=tapered;
      $('floodlight-wrap').hidden=!tapered;
      select('floodlight',tapered&&m?floodlights:[],v=>`${v.sku} · ${describe(v,'floodlight')} · ${money(v.price*(v.quantity||1))}`,true);
      $('camera-dedicated').hidden=!noLightBar;
      if(noLightBar)$('camera-dedicated').innerHTML=`<strong>${esc(t('camera_dedicated_heading'))}</strong><p>${esc(t('camera_dedicated_intro'))}</p>${m?`<p><strong>${esc(m.sku)}</strong> · ${esc(m.style)}${m.height?' '+esc(m.height)+'″':''} · ${money(m.price)}</p>`:`<p>${esc(t('camera_dedicated_empty'))}</p>`}`;
      $('radar-plate-note').hidden=!models.some(v=>v.requiredPlate);
      $('radar-plate-note').textContent=p&&models.some(v=>v.requiredPlate)?t('radar_plate_selected')+' '+p.sku:'';
      let rows=!noLightBar&&m&&p?grid.rowsFor(state.setup,m.sku,p.sku):null;
      // Each selection narrows the same rows, preventing accessories from
      // unrelated combinations from being mixed together by a union of SKUs.
      const candidates=(role,items)=>tapered||stainless&&role!=='top'?[]:items.filter(v=>grid.allows(rows,role,v.sku));
      const constrain=role=>{rows=grid.narrow(rows,role,get(role)?.sku);};
      select('bar',noLightBar||tapered?[]:fitBars(m,p,rows),barLabel,true);constrain('bar');
      const bar=get('bar');
      const acceptsTop=bar&&baseSku(bar.sku)!=='LTBSF5';
      select('top',acceptsTop?candidates('top',tops.filter(v=>stainless||v.color===state.finish||/^(LTBU|LTBUSS)$/.test(v.sku))):[],v=>`${v.sku} · ${describe(v,'top')} · ${money(v.price)}`,true);constrain('top');
      $('top-wrap').hidden=!acceptsTop;
      select('spreader',m&&p?candidates('spreader',spreaders.filter(v=>v.color===state.finish&&(rows!==null||v.sku.startsWith(m.family==='M1'?'SP1MOD':'SP2MOD')))):[],v=>`${v.sku} · ${v.options[1]} · ${money(v.price)}`,true);constrain('spreader');
      const flatHighPerformance=state.brand==='Starlink'&&state.model==='Performance Gen2 (formerly Flat HP)'&&p&&['ADAR1DMLTB','ADASTLKA'].includes(baseSku(p.sku));
      const starlinkWedgeOptions=flatHighPerformance?[
        {value:'',placeholder:true},
        ...starlinkWedges.filter(v=>v.color===state.finish).map(v=>({...v,seaviewWedge:true})),
        {value:'own',customerSupplied:true}
      ]:[];
      select('starlink-wedge',starlinkWedgeOptions,v=>v.placeholder?t('starlink_wedge_choose'):v.customerSupplied?t('starlink_wedge_own'):`${t('starlink_wedge_add')} · ${v.sku} · ${money(v.price)}`);
      $('starlink-wedge-wrap').hidden=!flatHighPerformance;
      $('starlink-wedge-note').hidden=!flatHighPerformance;
      $('starlink-wedge-note').textContent=flatHighPerformance?t('starlink_wedge_note'):'';
      const starlinkWedgeSelection=get('starlink-wedge');
      const matchingSeaviewWedge=starlinkWedgeSelection?.seaviewWedge?starlinkWedgeSelection:null;
      const hasStarlinkWedgeDecision=!flatHighPerformance||!!(starlinkWedgeSelection&&!starlinkWedgeSelection.placeholder);
      const wedgeChoices=m?candidates('wedge',wedges.filter(v=>v.options[1]?.startsWith(`${m.base}"`))):[];
      select('wedge',wedgeChoices,v=>`${v.sku} · ${v.options[0]} · ${money(v.price)}`,true);constrain('wedge');
      select('hinge',m?candidates('hinge',hinges.filter(v=>{
        if(v.sku==='SVEHB1')return [7,10].includes(m.base);
        const sku=baseSku(v.sku);
        return v.color===state.finish&&(sku==='PMH7'&&m.base===7&&m.height>=5&&m.height<=24||sku==='PMH10'&&m.base===10&&m.b!=='PMADM2M2');
      })):[],v=>`${v.sku} · ${v.sku==='SVEHB1'?t('electric_hinge'):(baseSku(v.sku)==='PMH7'?'7" × 7"':'10" × 10"')+' '+t('base')} · ${money(v.price)}`,true);constrain('hinge');
      select('removable',m&&!stainless&&!tapered?removables.filter(v=>v.color===state.finish&&baseSku(v.sku)===(m.base===7?'PMRB7':m.base===10?'PMRB10':'')):[],v=>`${v.sku} · ${m.base}" × ${m.base}" ${t('base')} · ${money(v.price)}`,true);
      $('hinge-note').textContent=t('hinge_rule');
      $('removable-note').textContent=t('removable_rule');
      const foldOK=m?.style==='aft'&&p&&['ADAR1','ADAS1','ADAS2'].includes(baseSku(p.sku))&&!state.spreader&&bar&&['LTBR','LTBS','LTBS24','LTB13','LTBRSS'].includes(baseSku(bar.sku));
      select('fold',foldOK?candidates('fold',folds):[],v=>`${v.sku} · ${t('fold')} · ${money(v.price)}`,true);
      $('fold-note').textContent=t('fold_rule');
      if(!m||(!integratedMount&&!p))warnings.push(t('no_fit'));
      if(tapered)warnings.push(t('tapered_review'));
      if(m?.sku==='PMA200V3'){warnings.push(t('mast_v3_photo_note'));if(state['mast-nav']==='led')warnings.push(t('mast_v3_preview_note'));}
      if(state.category==='sat')warnings.push(t('sat_review'));
      if(state.setup==='dual')warnings.push(t('dual_review'));
      if(state.category==='camera')warnings.push(t('camera_review'));
      if(/c700|special order/i.test(state.model))warnings.push(t('special_review'));
      if(state.model==='Performance Gen2 (formerly Flat HP)')warnings.push(t('hp_review'));
      if(flatHighPerformance&&starlinkWedgeSelection?.customerSupplied)warnings.push(t('starlink_wedge_customer_supplied'));
      if(/Halo open array/i.test(state.model))warnings.push(t('halo_note'));
      if(bar&&/^LTBSF/.test(bar.sku))warnings.push(t('camera_bar_review'));
      if(bar&&/^LTBSF[45]/.test(bar.sku)&&baseSku(p?.sku||'')!=='ADAR1DMLTB')warnings.push(t('radome_bar_review'));
      if(m?.family==='M2'&&state.setup==='single'&&['dome','open'].includes(state.category)&&baseSku(p?.sku||'')!=='ADAR1DMLTB')warnings.push(t('m2_radar_review'));
      if([state.hinge,state.wedge,state.removable].filter(Boolean).length>1)warnings.push(t('stack_review'));
      if(state.removable)warnings.push(t('removable_electrical'));
      if(state.removable&&state.finish==='black')warnings.push(t('removable_black'));
      if(get('hinge')?.sku==='SVEHB1')warnings.push(t('electric_review'));
      if(bar&&state.category==='starlink'&&!['ADAMINI','ADAG3','ADASPG3','ADAR1DMLTB'].includes(baseSku(p?.sku||'')))warnings.push(t('bar_review'));
      selected=(noLightBar?['mount']:tapered?['mount','floodlight']:['mount','plate','bar','top','spreader','floodlight','wedge','hinge','removable','fold']).map(k=>[k,k==='mount'?selectedMast:get(k)]).filter(([,v])=>v).map(([role,v])=>[role,{...v,shortDescription:describe(v,role)}]);
      if(matchingSeaviewWedge){
        const plateIndex=selected.findIndex(([role])=>role==='plate');
        selected.splice(plateIndex+1,0,['starlink_wedge',{...matchingSeaviewWedge,shortDescription:describe(matchingSeaviewWedge,'starlink_wedge')}]);
      }
      const unavailable=selected.some(([,v])=>!v.available&&!v.availabilityUnknown);
      if(unavailable)warnings.push(t('unavailable'));
      complete=!!(m&&(integratedMount||p)&&hasStarlinkWedgeDecision);
      $('warnings').hidden=!warnings.length;
      $('warnings').innerHTML=`<strong>${esc(t('review'))}</strong><ul>${uniq(warnings,x=>x).map(w=>`<li>${esc(w)}</li>`).join('')}</ul>`;
      $('count').textContent=String(selected.length);
      $('total').textContent=money(selected.reduce((n,[,v])=>n+v.price*(v.quantity||1),0));
      $('status').textContent=complete?(warnings.length?t('review_status'):t('matched_status')):t('incomplete_status');
      $('status').className='mb-status '+(complete&&!warnings.length?'is-matched':'');
      $('mount-note').textContent=m?(tapered?(m.sku==='PMA200V3'?t('mast_v3_included'):t('tapered_included')):stainless?t('steel')+' · '+t('steel_plate_included')+(state.category==='open'?' · '+t('steel_open_no_bar'):''):noLightBar?`${m.sku} · ${m.style}${m.height?' · '+m.height+'″':''}`:`${m.family} · ${m.style==='vertical'?t('drawing_round')+': '+m.base+'"':m.base+'" × '+m.base+'" '+t('base')} · ${t(m.style)}`):t('no_fit');
      if(!selected.some(([k])=>k===state.focus))state.focus=selected[0]?.[0]||'mount';
      const focused=selected.find(([k])=>k===state.focus);
      $('hero-image').innerHTML=focused?media(focused[1]):`<div class="mb-empty">${esc(t('choose_prompt'))}</div>`;
      $('hero-name').textContent=focused?focused[1].sku:'';
      $('hero-category').textContent=focused?t(focused[0]):'';
      $('mobile-image').innerHTML=focused?media(focused[1]):'';
      $('mobile-name').textContent=focused?focused[1].sku:'';
      $('mobile-total').textContent=money(selected.reduce((n,[,v])=>n+v.price*(v.quantity||1),0));
      $('thumbs').innerHTML=selected.map(([key,v],i)=>`<button type="button" data-focus="${key}" aria-pressed="${state.focus===key}" aria-label="${esc(t('view')+' '+v.sku)}">${media(v)}<span>${i+1}. ${esc(t(key))}</span><strong>${esc(v.sku)}</strong></button>`).join('');
      $('parts').innerHTML=selected.map(([key,v],i)=>`<li><span class="mb-part-n">${i+1}</span><span><span class="mb-part-role">${esc(t(key))}</span><a href="${esc(link(v))}" target="_blank" rel="noopener">${esc(v.sku)}</a><span class="mb-part-description">${esc(v.shortDescription)}</span>${!v.available&&!v.availabilityUnknown?`<small>${esc(t('unavailable_short'))}</small>`:''}</span><strong>${money(v.price*(v.quantity||1))}</strong><button type="button" class="mb-remove" data-remove="${key}" aria-label="${esc(t('remove')+' '+v.sku)}" title="${esc(t('remove')+' '+v.sku)}">×</button></li>`).join('');
      const hasReplacement=selected.some(([,v])=>v.draftReplacement);
      $('replacement-note').hidden=!hasReplacement;
      viewer.update(selected,state.focus);
      drawing.update(selected);
      const cart=$('cart');
      const cartBlocked=selected.some(([,v])=>v.draftReplacement||v.available===false||!Number.isSafeInteger(Number(v.id)));
      const orderable=root.dataset.orderingEnabled==='true'&&complete&&selected.length&&!cartBlocked;
      cart.disabled=!orderable;
      cart.textContent=t('add_to_cart');
      cart.title=orderable?'':(!complete?t('cart_incomplete'):cartBlocked?t('cart_unavailable'):t('draft_ordering'));
      $('copy').disabled=!selected.length;$('share').disabled=!selected.length;$('print').disabled=!selected.length;
      $('email').disabled=!selected.length;
      $('email-open').href='mailto:?subject='+encodeURIComponent(t('email_subject'));
      $('summary-line').textContent=[state.brand,state.model].filter(Boolean).join(' · ');
      $('print-notes').textContent=warnings.join(' ');
      $('live').textContent=`${selected.length} ${t('components')}. ${t('subtotal')} ${money(selected.reduce((n,[,v])=>n+v.price*(v.quantity||1),0))}. ${$('status').textContent}`;
    }
    root.addEventListener('change',e=>{
      const k=e.target.dataset.field;if(!savedKeys.includes(k))return;
      state[k]=e.target.value;
      if(['setup','category','brand','model','size','finish','lower','cameraStyle'].includes(k))for(const a of ['mount','plate','bar','top','spreader','floodlight','mast-nav','wedge','starlink-wedge','hinge','removable','fold'])state[a]='';
      if(k==='mount')for(const a of ['plate','bar','top','spreader','floodlight','mast-nav','wedge','starlink-wedge','hinge','removable','fold'])state[a]='';
      if(k==='plate')for(const a of ['bar','top','fold','starlink-wedge'])state[a]='';
      if(k==='bar'){state.top='';state.fold='';}
      state.focus=k==='starlink-wedge'?'starlink_wedge':['mount','plate','bar','top','spreader','floodlight','mast-nav','wedge','hinge','removable','fold'].includes(k)?k:'mount';
      render();$('feedback').textContent='';
    });
    root.addEventListener('click',async e=>{
      const b=e.target.closest('button');if(!b)return;
      if(b.hasAttribute('data-email')){
        if(!selected.length)return;
        $('email-preview').innerHTML=emailContent().html;
        $('email-result').textContent='';
        $('email-dialog').showModal();
        $('email-recipient').focus();
        return;
      }
      if(b.hasAttribute('data-email-close')){$('email-dialog').close();return;}
      if(b.hasAttribute('data-email-copy-open')||b.hasAttribute('data-email-copy-only')){
        const content=emailContent();
        b.disabled=true;
        const copied=await copyMountPartsEmail($('email-preview'),content);
        b.disabled=false;
        $('email-result').textContent=t(copied?'email_paste_ready':'email_copy_manual');
        if(copied&&b.hasAttribute('data-email-copy-open'))$('email-open').click();
        return;
      }
      if(b.hasAttribute('data-cart')){
        if(b.disabled)return;
        const items=selected.map(([,v])=>v).map(v=>({id:Number(v.id),quantity:v.quantity||1}));
        const cartRoot=root.dataset.cartRoot||'/';
        const cartPath=cartRoot.endsWith('/')?cartRoot:cartRoot+'/';
        b.disabled=true;b.textContent=t('adding_to_cart');
        try{
          const response=await fetch(cartPath+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
          if(!response.ok)throw new Error('cart-add-failed');
          b.textContent=t('cart_added');
          location.assign(cartPath+'cart');
        }catch{
          b.disabled=false;b.textContent=t('add_to_cart');$('feedback').textContent=t('cart_error');
        }
        return;
      }
      if(b.dataset.remove){
        const k=b.dataset.remove, stateKey=k==='starlink_wedge'?'starlink-wedge':k, removed=get(stateKey);state[stateKey]=['mount','plate'].includes(k)?'__none__':'';
        const dependencies=k==='mount'?['plate','bar','top','spreader','floodlight','mast-nav','wedge','starlink-wedge','hinge','removable','fold']:k==='plate'?['bar','top','spreader','starlink-wedge','fold']:k==='bar'?['top','fold']:[];
        for(const d of dependencies)state[d]=d==='plate'?'__none__':'';
        render();$('feedback').textContent=t('removed')+' '+(removed?.sku||'');$(stateKey)?.focus();return;
      }
      if(b.dataset.focus){state.focus=b.dataset.focus;render();return;}
      if(b.hasAttribute('data-copy')){
        try{await navigator.clipboard.writeText(partsText());$('feedback').textContent=t('copied');}catch{$('copy-area').hidden=false;$('copy-area').value=partsText();$('copy-area').select();$('feedback').textContent=t('copy_fallback');}
      }
      if(b.hasAttribute('data-share')){
        const u=buildURL();
        history.replaceState(null,'',u);
        try{await navigator.clipboard.writeText(u.href);$('feedback').textContent=t('link_copied');}catch{$('copy-area').hidden=false;$('copy-area').value=u.href;$('copy-area').select();$('feedback').textContent=t('copy_fallback');}
      }
      if(b.hasAttribute('data-print')){
        clearPrint();clearPrint=printMountSvg(mountPartsPrintMarkup(selected,$('summary-line').textContent,warnings,t,esc,money,orderingNote()),t('parts_list'),true);
      }
      if(b.hasAttribute('data-show-build'))root.querySelector('.mb-preview').scrollIntoView({behavior:'smooth',block:'start'});
      if(b.hasAttribute('data-reset')){Object.assign(state,{setup:'single',category:'dome',brand:'Garmin',model:'',finish:'white',size:'24',lower:'dome',cameraStyle:'light-bar',mount:'',plate:'',bar:'',top:'',spreader:'',floodlight:'','mast-nav':'',wedge:'','starlink-wedge':'',hinge:'',removable:'',fold:'',focus:'mount'});history.replaceState(null,'',location.pathname+location.search);render();$('feedback').textContent=t('reset_done');}
    });
    cleanLocation();render();root.classList.remove('mb-loading');
  };
  document.querySelectorAll('[data-modular-builder]').forEach(start);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-modular-builder]').forEach(start));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starlink-erp-safe-selector"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const delay = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

    const cartRoot = () => {
      const configuredRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      const root = configuredRoot || '/';
      return root.endsWith('/') ? root : `${root}/`;
    };

    const requestJson = async (url, options, timeoutMilliseconds) => {
      const controller = new AbortController();
      let timedOut = false;
      const timeout = window.setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, timeoutMilliseconds);

      try {
        const response = await fetch(url, {
          ...options,
          credentials: 'same-origin',
          signal: controller.signal
        });

        if (!response.ok) {
          const error = new Error('request_failed');
          error.status = response.status;
          throw error;
        }

        return await response.json();
      } catch (error) {
        if (timedOut) {
          const timeoutError = new Error('request_timeout');
          timeoutError.isTimeout = true;
          throw timeoutError;
        }
        throw error;
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const removePackageGroup = async (root, group, observationMilliseconds, quietMilliseconds) => {
      const deadline = Date.now() + observationMilliseconds;
      let absentSince = null;
      let finalObservation = false;

      do {
        finalObservation = Date.now() >= deadline;

        try {
          const cart = await requestJson(`${root}cart.js`, { headers: { Accept: 'application/json' } }, 8000);
          const match = (cart.items || []).find((item) => {
            return item.properties && item.properties._starlink_package_group === group;
          });

          if (match) {
            absentSince = null;
            await requestJson(
              `${root}cart/change.js`,
              {
                method: 'POST',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id: match.key, quantity: 0 })
              },
              8000
            );
          } else {
            if (absentSince === null) absentSince = Date.now();
          }
        } catch (error) {
          absentSince = null;
        }

        if (!finalObservation) {
          await delay(Math.min(500, Math.max(0, deadline - Date.now())));
        }
      } while (!finalObservation);

      return absentSince !== null && Date.now() - absentSince >= quietMilliseconds;
    };

    const createGroup = () => {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return `starlink-${window.crypto.randomUUID()}`;
      }

      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        const values = new Uint32Array(4);
        window.crypto.getRandomValues(values);
        return `starlink-${Array.from(values).join('-')}`;
      }

      return `starlink-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    };

    const relocateProductSelector = (selector) => {
      if (!selector.dataset.starlinkFixedFamily || selector.dataset.relocated === 'true') return;
      if (window.Shopify && window.Shopify.designMode) return;

      const productSection = document.querySelector('#shopify-section-product-template');
      if (!productSection) return;

      const nativeProductForm = Array.from(
        productSection.querySelectorAll('form[action*="/cart/add"]')
      ).find((form) => !selector.contains(form) && form.querySelector('[name="id"]'));
      const nativeProductFormContainer = nativeProductForm
        && (nativeProductForm.closest('.product_form') || nativeProductForm);

      if (!nativeProductFormContainer || !nativeProductFormContainer.parentElement) return;

      nativeProductFormContainer.insertAdjacentElement('afterend', selector);
      selector.dataset.relocated = 'true';
    };

    const initialize = (selector) => {
      relocateProductSelector(selector);
      if (selector.dataset.initialized === 'true') return;

      const sectionId = selector.dataset.sectionId;
      const dataNode = Array.from(document.querySelectorAll('[data-starlink-selector-data]')).find((node) => {
        return node.dataset.starlinkSelectorData === sectionId;
      });
      if (!dataNode) return;

      let configuration;
      try {
        configuration = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      const fixedFamilyKey = selector.dataset.starlinkFixedFamily || '';
      if (fixedFamilyKey) {
        const fixedFamily = configuration.families.find((family) => family.key === fixedFamilyKey);
        configuration.families = fixedFamily ? [fixedFamily] : [];
      }

      const form = selector.querySelector('[data-starlink-form]');
      const familyInputs = Array.from(selector.querySelectorAll('input[type="radio"]'));
      const mountSelect = selector.querySelector('[data-starlink-mount]');
      const quantityInput = selector.querySelector('[data-starlink-quantity]');
      const priceOutput = selector.querySelector('[data-starlink-price]');
      const antennaSku = selector.querySelector('[data-starlink-antenna-sku]');
      const mountSku = selector.querySelector('[data-starlink-mount-sku]');
      const mountRow = selector.querySelector('[data-starlink-mount-row]');
      const mountPreview = selector.querySelector('[data-starlink-mount-preview]');
      const mountImage = selector.querySelector('[data-starlink-mount-image]');
      const mountName = selector.querySelector('[data-starlink-mount-name]');
      const mountPreviewSku = selector.querySelector('[data-starlink-mount-preview-sku]');
      const submit = selector.querySelector('[data-starlink-submit]');
      const status = selector.querySelector('[data-starlink-status]');
      const cartReview = selector.querySelector('[data-starlink-cart-review]');
      const labels = configuration.labels;
      const catalog = configuration.catalog || {};
      let catalogComplete = configuration.families.length > 0 && familyInputs.length > 0;

      familyInputs.forEach((input) => {
        if (!configuration.families.some((family) => family.key === input.value)) {
          catalogComplete = false;
        }
      });

      configuration.families.forEach((family) => {
        const liveAntenna = catalog[String(family.antenna.id)];

        if (!liveAntenna || liveAntenna.sku !== family.antenna.sku) {
          catalogComplete = false;
          return;
        }

        family.antenna = { ...family.antenna, ...liveAntenna };

        family.options.forEach((option) => {
          if (!option.mount) {
            option.packagePriceCents = family.antenna.priceCents;
            option.available = family.antenna.available;
            return;
          }

          const liveMount = catalog[String(option.mount.id)];

          if (!liveMount || liveMount.sku !== option.mount.sku) {
            catalogComplete = false;
            option.available = false;
            return;
          }

          option.mount = { ...option.mount, ...liveMount };
          option.packagePriceCents = family.antenna.priceCents
            + liveMount.priceCents
            - Math.round(liveMount.priceCents * 0.2);
          option.available = family.antenna.available && liveMount.available;
        });
      });

      delete configuration.catalog;

      const formatter = new Intl.NumberFormat(configuration.locale || document.documentElement.lang || 'en', {
        style: 'currency',
        currency: configuration.currency || 'USD'
      });

      if (!catalogComplete) {
        status.setAttribute('role', 'alert');
        status.textContent = labels.errorConfiguration;
        familyInputs.forEach((input) => { input.disabled = true; });
        mountSelect.disabled = true;
        quantityInput.disabled = true;
        submit.disabled = true;
        selector.dataset.initialized = 'true';
        return;
      }

      const currentFamily = () => {
        const checked = familyInputs.find((input) => input.checked);
        return configuration.families.find((family) => family.key === checked.value);
      };

      const currentOption = () => {
        const family = currentFamily();
        return family.options.find((option) => option.key === mountSelect.value) || family.options[0];
      };

      const formatSku = (sku) => labels.sku.replace('__SKU__', sku);

      const formatOption = (option) => {
        return labels.optionPrice
          .replace('__OPTION__', option.label)
          .replace('__PRICE__', formatter.format(option.packagePriceCents / 100));
      };

      const quantity = () => {
        const value = Number(quantityInput.value);
        return Number.isInteger(value) && value >= 1 ? value : null;
      };

      const updateSummary = () => {
        const family = currentFamily();
        const option = currentOption();
        const selectedQuantity = quantity() || 1;
        priceOutput.textContent = formatter.format((option.packagePriceCents * selectedQuantity) / 100);
        antennaSku.textContent = formatSku(family.antenna.sku);

        if (option.mount) {
          mountSku.textContent = formatSku(option.mount.sku);
          mountRow.hidden = false;
          mountName.textContent = option.label;
          mountPreviewSku.textContent = formatSku(option.mount.sku);

          if (option.mount.imageUrl) {
            mountImage.src = option.mount.imageUrl;
            mountImage.alt = option.mount.imageAlt || option.label;
            mountPreview.hidden = false;
          } else {
            mountImage.removeAttribute('src');
            mountImage.alt = '';
            mountPreview.hidden = true;
          }
        } else {
          mountSku.textContent = '';
          mountRow.hidden = true;
          mountName.textContent = '';
          mountPreviewSku.textContent = '';
          mountImage.removeAttribute('src');
          mountImage.alt = '';
          mountPreview.hidden = true;
        }
      };

      const updateMounts = () => {
        const family = currentFamily();
        mountSelect.replaceChildren();
        let firstAvailable = null;

        family.options.forEach((option) => {
          const optionElement = new Option(formatOption(option), option.key);
          optionElement.disabled = !option.available;
          mountSelect.add(optionElement);
          if (!firstAvailable && option.available) firstAvailable = option;
        });

        if (firstAvailable) mountSelect.value = firstAvailable.key;
        mountSelect.disabled = !firstAvailable;
        submit.disabled = !firstAvailable;
        updateSummary();
      };

      const setBusy = (busy) => {
        submit.disabled = busy || !currentOption().available;
        submit.textContent = busy ? labels.adding : labels.addToCart;
        form.setAttribute('aria-busy', busy ? 'true' : 'false');
        familyInputs.forEach((input) => { input.disabled = busy; });
        mountSelect.disabled = busy || !currentFamily().options.some((option) => option.available);
        quantityInput.disabled = busy;
      };

      const clearValidation = () => {
        quantityInput.removeAttribute('aria-invalid');
        status.setAttribute('role', 'status');
        status.textContent = '';
        cartReview.hidden = true;
      };

      const addResponseMatches = (response, expectedItems, group) => {
        const returnedItems = response && Array.isArray(response.items) ? response.items : [];
        if (!returnedItems.length) return false;

        const matchesExpectedItem = (returnedItem, expectedItem) => {
          const returnedProperties = returnedItem.properties || {};
          const returnedVariantId = returnedItem.variant_id || returnedItem.id;

          return String(returnedVariantId) === String(expectedItem.id)
            && returnedItem.sku === expectedItem.sku
            && returnedProperties._starlink_package_group === group
            && returnedProperties._starlink_package_role === expectedItem.role;
        };

        return expectedItems.every((expectedItem) => {
          const returnedQuantity = returnedItems
            .filter((returnedItem) => matchesExpectedItem(returnedItem, expectedItem))
            .reduce((sum, returnedItem) => sum + Number(returnedItem.quantity || 0), 0);

          return returnedQuantity === expectedItem.quantity;
        }) && returnedItems.every((returnedItem) => {
          return expectedItems.some((expectedItem) => matchesExpectedItem(returnedItem, expectedItem));
        });
      };

      familyInputs.forEach((input) => input.addEventListener('change', () => {
        clearValidation();
        updateMounts();
      }));

      document.querySelectorAll('[data-starlink-family-choice]').forEach((link) => {
        const input = familyInputs.find((familyInput) => {
          return familyInput.value === link.dataset.starlinkFamilyChoice;
        });

        if (!input) return;

        link.addEventListener('click', () => {
          if (input.disabled) return;
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          window.requestAnimationFrame(() => input.focus({ preventScroll: true }));
        });
      });

      mountSelect.addEventListener('change', () => {
        clearValidation();
        updateSummary();
      });
      quantityInput.addEventListener('input', () => {
        clearValidation();
        updateSummary();
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;

        const selectedQuantity = quantity();

        if (!selectedQuantity) {
          status.setAttribute('role', 'alert');
          status.textContent = labels.errorQuantity;
          quantityInput.setAttribute('aria-invalid', 'true');
          quantityInput.focus();
          return;
        }

        const family = currentFamily();
        const option = currentOption();

        if (!option.available) {
          status.setAttribute('role', 'alert');
          status.textContent = labels.errorUnavailable;
          return;
        }

        const group = createGroup();
        const properties = (role) => ({
          _starlink_package_group: group,
          _starlink_package_role: role
        });
        const expectedItems = [
          {
            id: family.antenna.id,
            sku: family.antenna.sku,
            role: 'antenna',
            quantity: selectedQuantity
          }
        ];

        if (option.mount) {
          expectedItems.push({
            id: option.mount.id,
            sku: option.mount.sku,
            role: 'mount',
            quantity: selectedQuantity
          });
        }

        const items = expectedItems.map((expectedItem) => {
          return {
            id: expectedItem.id,
            quantity: expectedItem.quantity,
            properties: properties(expectedItem.role)
          };
        });

        const root = cartRoot();
        status.setAttribute('role', 'status');
        status.textContent = labels.adding;
        cartReview.hidden = true;
        form.dataset.submitting = 'true';
        setBusy(true);

        let addAttempted = false;

        try {
          addAttempted = true;
          const addResponse = await requestJson(
            `${root}cart/add.js`,
            {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items })
            },
            15000
          );

          if (!addResponseMatches(addResponse, expectedItems, group)) {
            throw new Error('unexpected_cart_response');
          }

          const cartAfter = await requestJson(
            `${root}cart.js`,
            { headers: { Accept: 'application/json' } },
            8000
          );
          const groupedCartItems = (cartAfter.items || []).filter((item) => {
            return item.properties && item.properties._starlink_package_group === group;
          });

          if (!addResponseMatches({ items: groupedCartItems }, expectedItems, group)) {
            throw new Error('unexpected_cart_state');
          }

          const groupedPricesValid = groupedCartItems.every((item) => {
            return Number.isInteger(Number(item.final_line_price));
          });
          const groupFinalTotal = groupedCartItems.reduce((sum, item) => {
            return sum + Number(item.final_line_price || 0);
          }, 0);
          const expectedIncrease = option.packagePriceCents * selectedQuantity;
          const roundingTolerance = Math.max(1, selectedQuantity);

          if (!groupedPricesValid || groupFinalTotal > expectedIncrease + roundingTolerance) {
            const discountError = new Error('expected_discount_missing');
            discountError.isPriceMismatch = true;
            throw discountError;
          }
        } catch (error) {
          const ambiguousWrite = addAttempted
            && !error.isPriceMismatch
            && (
              error.isTimeout
              || !Number.isInteger(error.status)
              || error.status === 408
              || error.status >= 500
            );

          status.setAttribute('role', 'status');
          let cleaned = true;

          if (addAttempted) {
            status.textContent = labels.cleaningUp;
            cleaned = await removePackageGroup(
              root,
              group,
              ambiguousWrite ? 20000 : 8000,
              ambiguousWrite ? 5000 : 2000
            );
          }

          status.setAttribute('role', 'alert');
          if (!cleaned) {
            status.textContent = labels.errorCleanup;
          } else if (error.isPriceMismatch) {
            status.textContent = labels.errorDiscount;
          } else if (ambiguousWrite) {
            status.textContent = labels.errorTimeout;
          } else if (error.status === 422) {
            status.textContent = labels.errorUnavailable;
          } else {
            status.textContent = labels.errorGeneric;
          }

          status.focus();
          if (ambiguousWrite || !cleaned || error.isPriceMismatch) {
            cartReview.hidden = !ambiguousWrite && cleaned;
            submit.textContent = labels.addToCart;
            form.setAttribute('aria-busy', 'false');
            return;
          }

          delete form.dataset.submitting;
          setBusy(false);
          return;
        }

        window.location.assign(`${root}cart`);
      });

      window.addEventListener('pageshow', (event) => {
        if (!event.persisted) return;
        delete form.dataset.submitting;
        setBusy(false);
        clearValidation();
      });

      selector.dataset.initialized = 'true';
      updateMounts();
    };

    const initializeAll = (scope) => {
      scope.querySelectorAll('[data-starlink-selector]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(document));
    } else {
      initializeAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
